import React from 'react';
import { FormattedMessage } from 'react-intl';
import { VEARROW } from './Referendum';
import { openUrl } from '../../utils/navigation';

const POOL_REF_PC = () => {
  return (
    <svg
      width="59"
      height="75"
      viewBox="0 0 59 75"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.0955 67.6718C28.0877 70.3492 39.9553 58.4599 44.6025 41.1163C49.2498 23.7726 44.9168 7.54237 34.9245 4.86496C24.9323 2.18756 13.0647 14.0769 8.41751 31.4205C3.77029 48.7642 8.10328 64.9944 18.0955 67.6718ZM18.6499 65.6044C27.5002 67.9758 38.194 56.7642 42.5352 40.5625C46.8764 24.3608 43.2212 9.30437 34.3709 6.93295C25.5207 4.56153 14.8268 15.7732 10.4856 31.9748C6.1444 48.1765 9.79969 63.233 18.6499 65.6044Z"
        fill="white"
      />
      <path
        d="M44.1196 40.9869C41.8145 49.5896 37.724 56.8156 32.9995 61.5487C28.2641 66.2928 22.9749 68.4616 18.2249 67.1889L17.9661 68.1548C23.2083 69.5594 28.849 67.1223 33.7073 62.2552C38.5764 57.3771 42.7434 49.9866 45.0855 41.2457L44.1196 40.9869ZM34.7951 5.34793C39.5451 6.62069 43.0413 11.1435 44.7702 17.6198C46.4952 24.081 46.4247 32.3842 44.1196 40.9869L45.0855 41.2457C47.4276 32.5047 47.5142 24.0209 45.7364 17.3618C43.9626 10.7176 40.2962 5.78665 35.054 4.382L34.7951 5.34793ZM8.90047 31.5499C11.2056 22.9472 15.296 15.7212 20.0205 10.9881C24.7559 6.24399 30.0451 4.07517 34.7951 5.34793L35.054 4.382C29.8117 2.97735 24.171 5.41449 19.3128 10.2816C14.4436 15.1597 10.2767 22.5502 7.93454 31.2911L8.90047 31.5499ZM18.2249 67.1889C13.4749 65.9161 9.97875 61.3933 8.2498 54.917C6.52483 48.4558 6.59539 40.1526 8.90047 31.5499L7.93454 31.2911C5.59241 40.0321 5.50586 48.5159 7.28363 55.175C9.05743 61.8192 12.7239 66.7501 17.9661 68.1548L18.2249 67.1889ZM42.0523 40.4331C39.8991 48.4689 36.1758 55.2431 31.9217 59.7033C27.6527 64.1789 22.9453 66.2377 18.7793 65.1214L18.5205 66.0874C23.2049 67.3425 28.2694 64.9812 32.6453 60.3935C37.0359 55.7903 40.8302 48.8577 43.0182 40.6919L42.0523 40.4331ZM34.2415 7.41591C38.4074 8.53216 41.4548 12.6689 42.914 18.6793C44.3681 24.6691 44.2055 32.3973 42.0523 40.4331L43.0182 40.6919C45.2062 32.5261 45.3865 24.6252 43.8858 18.4434C42.39 12.2824 39.1847 7.70516 34.5003 6.44999L34.2415 7.41591ZM10.9686 32.1043C13.1218 24.0684 16.845 17.2943 21.0992 12.8341C25.3681 8.35845 30.0756 6.29966 34.2415 7.41591L34.5003 6.44999C29.816 5.19482 24.7514 7.55614 20.3756 12.1439C15.985 16.7471 12.1907 23.6796 10.0027 31.8454L10.9686 32.1043ZM18.7793 65.1214C14.6134 64.0052 11.566 59.8685 10.1069 53.858C8.65273 47.8683 8.81539 40.1401 10.9686 32.1043L10.0027 31.8454C7.81463 40.0113 7.63433 47.9121 9.13509 54.0939C10.6308 60.255 13.8362 64.8322 18.5205 66.0874L18.7793 65.1214Z"
        fill="black"
      />
      <path
        d="M15.2668 33.2561C11.9078 45.7921 13.4802 64.2193 24.845 65.2276C22.7487 65.9822 20.652 66.141 18.6495 65.6044C9.79928 63.233 6.144 48.1766 10.4852 31.9749C14.8264 15.7732 25.5202 4.56157 34.3705 6.93299C36.3729 7.46954 38.1094 8.65545 39.5475 10.3571C28.1751 7.30984 18.6258 20.7202 15.2668 33.2561Z"
        fill="white"
        stroke="black"
      />
      <path
        d="M39.5483 10.3566C38.1102 8.65498 36.3737 7.46906 34.3713 6.93252C26.3859 4.79283 16.8996 13.7113 11.933 27.3757C11.933 27.3757 12.3534 27.0729 13.7218 28.6861C15.0901 30.2994 15.2676 33.2556 15.2676 33.2556C18.6266 20.7197 28.1758 7.30936 39.5483 10.3566Z"
        fill="#00C6A2"
        stroke="black"
      />
      <path
        d="M39.5481 10.3572C38.11 8.6556 36.3736 7.46969 34.3711 6.93314C30.1832 5.81098 25.5824 7.73032 21.4373 11.7807C21.4373 11.7807 22.1578 12.6638 22.4601 14.6839C22.7623 16.7041 22.2775 18.5133 22.2775 18.5133C26.8147 12.4572 32.8668 8.56696 39.5481 10.3572Z"
        fill="black"
        stroke="black"
      />
      <path
        d="M19.8662 17.5747L33.2443 21.1594L38.8772 22.6687C40.1882 23.4089 41.0943 24.7212 41.2075 25.2376L39.6044 26.9957L41.4501 27.4902C41.7414 27.8113 42.5488 29.9587 40.5617 35.0303C39.0888 38.7898 35.5115 41.6983 33.6297 41.6802L38.0338 55.7429L32.3124 54.2098L11.5412 48.6442L15.4302 34.13L19.0932 30.4932L16.5848 29.8211L19.8662 17.5747Z"
        fill="white"
      />
      <path
        d="M33.2443 21.1594L19.8662 17.5747L16.5848 29.8211M33.2443 21.1594C33.9484 21.348 35.5411 22.1637 36.2787 23.917M33.2443 21.1594L38.8772 22.6687C40.1882 23.4089 41.0943 24.7212 41.2075 25.2376M36.2787 23.917L25.8472 33.2752M36.2787 23.917L41.2075 25.2376M25.8472 33.2752L28.7329 34.0484M25.8472 33.2752L24.3153 28.7326M16.5848 29.8211L22.6932 23.9227L24.3153 28.7326M16.5848 29.8211L19.0932 30.4932M37.1401 26.3354C37.4313 26.6565 38.259 28.8118 36.2517 33.8755C34.6141 38.0064 30.2564 40.2902 28.1399 40.2093M37.1401 26.3354L39.6044 26.9957M37.1401 26.3354L28.7329 34.0484M21.5994 28.0049L24.6319 37.8109L28.7329 34.0484M21.5994 28.0049L19.0932 30.4932M21.5994 28.0049L24.3153 28.7326M32.3124 54.2098L11.5412 48.6442L15.4302 34.13L19.0932 30.4932M32.3124 54.2098L28.1399 40.2093M32.3124 54.2098L38.0338 55.7429L33.6297 41.6802M28.1399 40.2093L33.6297 41.6802M33.6297 41.6802C35.5115 41.6983 39.0888 38.7898 40.5617 35.0303C42.5488 29.9587 41.7414 27.8113 41.4501 27.4902L39.6044 26.9957M41.2075 25.2376L39.6044 26.9957"
        stroke="black"
      />
      <path
        d="M16.584 29.8208L22.6924 23.9225L24.3145 28.7324L21.5986 28.0046L19.0924 30.493L16.584 29.8208Z"
        fill="black"
        stroke="black"
      />
      <path
        d="M25.8474 33.2753L36.2789 23.917L43.5283 25.8595L41.6398 27.5411L37.1402 26.3354L28.7331 34.0485L25.8474 33.2753Z"
        fill="black"
        stroke="black"
      />
      <path
        d="M37.8506 20.8672L41.3711 21.8105L46.8698 23.2839L45.2291 29.4071L39.7304 27.9337L37.8506 20.8672Z"
        fill="#00C6A2"
      />
      <path
        d="M41.3711 21.8105L37.8506 20.8672L39.7304 27.9337M41.3711 21.8105L39.7304 27.9337M41.3711 21.8105L46.8698 23.2839L45.2291 29.4071L39.7304 27.9337"
        stroke="black"
      />
      <path
        d="M33.2443 21.1594L19.8662 17.5747L16.5848 29.8211L22.6932 23.9227L25.8472 33.2752L36.2787 23.917C36.2787 23.917 35.5033 21.7647 33.2443 21.1594Z"
        fill="#00C6A2"
      />
      <path
        d="M21.5994 28.0049L24.6319 37.8109L28.7329 34.0484L37.1401 26.3354C37.4313 26.6565 38.259 28.8118 36.2517 33.8755C34.6141 38.0064 30.2564 40.2902 28.1399 40.2093L32.3124 54.2098L11.5412 48.6442L15.4302 34.13L19.0932 30.4932L21.5994 28.0049Z"
        fill="#00C6A2"
      />
      <path
        d="M33.2443 21.1594L19.8662 17.5747L16.5848 29.8211L22.6932 23.9227L25.8472 33.2752L36.2787 23.917C36.2787 23.917 35.5033 21.7647 33.2443 21.1594Z"
        stroke="black"
      />
      <path
        d="M21.5994 28.0049L24.6319 37.8109L28.7329 34.0484L37.1401 26.3354C37.4313 26.6565 38.259 28.8118 36.2517 33.8755C34.6141 38.0064 30.2564 40.2902 28.1399 40.2093L32.3124 54.2098L11.5412 48.6442L15.4302 34.13L19.0932 30.4932L21.5994 28.0049Z"
        stroke="black"
      />
      <path
        d="M50.2884 42.64C45.6411 59.9836 33.7735 71.873 23.7813 69.1956C22.1261 68.7521 17.8366 67.6027 17.8366 67.6027C30.3562 69.9877 40.9673 54.6825 44.8447 40.2118C48.8087 25.418 45.6506 7.7392 34.4072 4.72656C34.4072 4.72656 39.1413 5.99507 40.6104 6.38869C50.6026 9.0661 54.9356 25.2964 50.2884 42.64Z"
        fill="white"
        stroke="black"
      />
      <path
        d="M17.8362 67.6025L23.7809 69.1954C32.8882 71.6357 43.5534 61.9751 48.8897 47.1131C48.8897 47.1131 47.7838 46.8168 46.2355 44.3243C44.6872 41.8318 44.8443 40.2116 44.8443 40.2116C40.9669 54.6823 30.3558 69.9875 17.8362 67.6025Z"
        fill="#00C6A2"
        stroke="black"
      />
      <path
        d="M17.8371 67.6025L23.7818 69.1954C29.2825 70.6693 35.3515 67.7288 40.4714 61.894C40.4714 61.894 39.2101 60.725 38.5225 59.1557C37.8349 57.5863 38.0868 55.5761 38.0868 55.5761C32.9157 63.5387 25.7585 69.1115 17.8371 67.6025Z"
        fill="black"
        stroke="black"
      />
      <path
        d="M18.6478 65.6046C27.4981 67.976 38.1919 56.7643 42.5331 40.5627C46.8743 24.361 43.2191 9.30455 34.3688 6.93313L34.9228 4.86541C42.0399 6.21837 50.349 19.6641 44.6008 41.1167C38.9912 62.0521 25.4854 70.0684 18.0938 67.6723L18.6478 65.6046Z"
        fill="white"
      />
      <path
        d="M18.0938 67.6726C28.086 70.35 39.9536 58.4607 44.6008 41.117C49.2481 23.7734 44.9151 7.54313 34.9229 4.86572"
        stroke="black"
      />
      <path
        d="M18.6482 65.605C27.4984 67.9765 38.1922 56.7648 42.5335 40.5631C46.8747 24.3615 43.2194 9.30501 34.3691 6.93359"
        stroke="black"
      />
    </svg>
  );
};

const POOL_NEAR_PC = () => {
  return (
    <svg
      width="60"
      height="75"
      viewBox="0 0 60 75"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.9451 68.5004C28.9373 71.1779 40.8049 59.2885 45.4521 41.9449C50.0994 24.6012 45.7664 8.37099 35.7742 5.69358C25.7819 3.01617 13.9143 14.9055 9.26712 32.2491C4.6199 49.5928 8.95289 65.823 18.9451 68.5004ZM19.4994 66.433C28.3496 68.8044 39.0434 57.5928 43.3847 41.3911C47.7259 25.1895 44.0706 10.133 35.2203 7.76158C26.3701 5.39016 15.6763 16.6018 11.3351 32.8035C6.99383 49.0051 10.6491 64.0616 19.4994 66.433Z"
        fill="white"
      />
      <path
        d="M44.9692 41.8155C42.6641 50.4182 38.5736 57.6442 33.8491 62.3773C29.1137 67.1214 23.8245 69.2902 19.0745 68.0175L18.8157 68.9834C24.0579 70.3881 29.6986 67.9509 34.5569 63.0838C39.426 58.2057 43.593 50.8152 45.9351 42.0743L44.9692 41.8155ZM35.6447 6.17654C40.3947 7.4493 43.8909 11.9722 45.6199 18.4484C47.3448 24.9097 47.2743 33.2128 44.9692 41.8155L45.9351 42.0743C48.2772 33.3333 48.3638 24.8495 46.586 18.1904C44.8122 11.5462 41.1458 6.61526 35.9036 5.21062L35.6447 6.17654ZM9.75008 32.3785C12.0552 23.7759 16.1456 16.5499 20.8701 11.8167C25.6056 7.07261 30.8947 4.90378 35.6447 6.17654L35.9036 5.21062C30.6613 3.80597 25.0206 6.2431 20.1624 11.1102C15.2932 15.9883 11.1263 23.3788 8.78415 32.1197L9.75008 32.3785ZM19.0745 68.0175C14.3245 66.7447 10.8284 62.2219 9.09941 55.7457C7.37444 49.2844 7.445 40.9812 9.75008 32.3785L8.78415 32.1197C6.44202 40.8607 6.35547 49.3445 8.13324 56.0036C9.90704 62.6478 13.5735 67.5788 18.8157 68.9834L19.0745 68.0175ZM42.9017 41.2617C40.7485 49.2976 37.0253 56.0717 32.7711 60.5319C28.5022 65.0075 23.7947 67.0663 19.6288 65.9501L19.37 66.916C24.0543 68.1712 29.1189 65.8098 33.4947 61.2221C37.8853 56.6189 41.6796 49.6864 43.8676 41.5205L42.9017 41.2617ZM35.0909 8.24454C39.2568 9.36079 42.3042 13.4975 43.7634 19.508C45.2176 25.4977 45.0549 33.2259 42.9017 41.2617L43.8676 41.5205C46.0557 33.3547 46.236 25.4538 44.7352 19.2721C43.2395 13.111 40.0341 8.53378 35.3498 7.27862L35.0909 8.24454ZM11.818 32.9329C13.9712 24.897 17.6944 18.1229 21.9486 13.6627C26.2175 9.18708 30.925 7.12829 35.0909 8.24454L35.3498 7.27862C30.6654 6.02345 25.6009 8.38477 21.225 12.9725C16.8344 17.5757 13.0401 24.5082 10.8521 32.6741L11.818 32.9329ZM19.6288 65.9501C15.4629 64.8338 12.4155 60.6971 10.9563 54.6866C9.50216 48.6969 9.66483 40.9687 11.818 32.9329L10.8521 32.6741C8.66407 40.8399 8.48376 48.7408 9.98453 54.9226C11.4803 61.0836 14.6856 65.6608 19.37 66.916L19.6288 65.9501Z"
        fill="black"
      />
      <path
        d="M16.1174 34.0842C12.7584 46.6202 14.3308 65.0475 25.6956 66.0557C23.5993 66.8103 21.5025 66.9691 19.5001 66.4326C10.6499 64.0611 6.99458 49.0047 11.3358 32.803C15.677 16.6013 26.3708 5.3897 35.2211 7.76112C37.2235 8.29766 38.96 9.48358 40.3981 11.1852C29.0256 8.13796 19.4764 21.5483 16.1174 34.0842Z"
        fill="white"
        stroke="black"
      />
      <path
        d="M40.3979 11.1852C38.9598 9.48359 37.2233 8.29768 35.2209 7.76113C27.2355 5.62145 17.7492 14.5399 12.7826 28.2044C12.7826 28.2044 13.203 27.9015 14.5714 29.5147C15.9397 31.128 16.1172 34.0842 16.1172 34.0842C19.4762 21.5483 29.0254 8.13798 40.3979 11.1852Z"
        fill="#00C6A2"
        stroke="black"
      />
      <path
        d="M40.3977 11.1849C38.9596 9.48324 37.2232 8.29732 35.2207 7.76078C31.0328 6.63862 26.4321 8.55796 22.287 12.6083C22.287 12.6083 23.0074 13.4914 23.3097 15.5116C23.6119 17.5317 23.1271 19.3409 23.1271 19.3409C27.6643 13.2848 33.7164 9.39459 40.3977 11.1849Z"
        fill="black"
        stroke="black"
      />
      <path
        d="M20.7129 23.6543L23.801 31.9975L21.648 40.0323L14.9195 45.2754L20.7129 23.6543Z"
        fill="white"
        stroke="black"
      />
      <path
        d="M20.7139 23.6543L23.802 31.9975L22.5102 36.8184C20.9765 32.0233 18.5218 31.8353 18.5218 31.8353L20.7139 23.6543Z"
        fill="black"
        stroke="black"
      />
      <path
        d="M26.6543 19.4009L21.5768 18.0926L31.8371 49.3389L34.1074 40.8658C32.3896 35.395 28.6206 22.2704 28.3437 21.4716C27.7256 19.688 27.1412 19.5314 26.6543 19.4009Z"
        fill="white"
        stroke="black"
      />
      <path
        d="M30.4795 36.292C28.8047 35.5301 27.2188 33.8525 27.2188 33.8525L31.8376 49.3387L34.108 40.8655L32.7491 36.587C32.7491 36.587 32.1543 37.0539 30.4795 36.292Z"
        fill="white"
        stroke="black"
      />
      <path
        d="M30.626 36.3311C28.9512 35.5692 27.3652 33.8916 27.3652 33.8916L31.9841 49.3778L34.2545 40.9046L32.8956 36.6261C32.8956 36.6261 32.3008 37.093 30.626 36.3311Z"
        fill="black"
        stroke="black"
      />
      <path
        d="M26.7821 40.1554L23.422 39.2551L13.706 49.8042L17.0735 50.7065C18.942 51.2071 20.9317 50.5851 22.1822 49.1093L27.9193 42.339C27.9193 42.339 28.1456 40.5207 26.7821 40.1554Z"
        fill="white"
        stroke="black"
      />
      <path
        d="M26.7822 40.1554L23.4222 39.2551L20.2418 42.9436C20.2418 42.9436 21.0792 43.3246 21.9739 44.6603C22.8686 45.9961 23.1293 47.9449 23.1293 47.9449L27.9195 42.339C27.9195 42.339 28.1457 40.5207 26.7822 40.1554Z"
        fill="black"
        stroke="black"
      />
      <path
        d="M43.2264 24.3629L39.8664 23.4626L30.1504 34.0117L33.5179 34.914C35.3864 35.4147 37.376 34.7926 38.6266 33.3168L44.3637 26.5466C44.3637 26.5466 44.5899 24.7283 43.2264 24.3629Z"
        fill="black"
        stroke="black"
      />
      <path
        d="M45.1754 24.1023L40.3545 22.8105L31.7819 54.804L33.3802 55.2322C36.0475 55.9469 38.7892 54.364 39.5039 51.6967L46.3127 26.286C46.3127 26.286 46.5389 24.4677 45.1754 24.1023Z"
        fill="white"
        stroke="black"
      />
      <path
        d="M21.5771 18.0925C20.1747 17.7167 19.4944 19.048 19.3152 19.5219L11.7212 47.8631C11.6394 48.3631 11.7388 49.4336 12.7906 49.7154C13.8425 49.9973 14.4917 50.1712 15.256 49.28C17.9128 46.1818 22.8854 40.2073 23.1588 39.6542C23.4322 39.1012 22.9615 39.0272 22.6919 39.0594C21.0308 40.3888 17.5235 43.1547 16.7826 43.5825C16.0417 44.0103 16.1174 43.1433 16.2479 42.6563L20.906 25.2718L29.7187 53.1552C30.0004 53.857 30.6134 54.491 31.7821 54.8042C32.9509 55.1173 33.8379 54.7287 34.0727 53.8522L41.9016 24.6344C42.0973 23.904 41.1436 23.0222 40.2087 22.7716C39.2737 22.5211 38.5199 22.8411 38.2599 23.0323C35.5804 26.02 30.116 32.1551 29.6944 32.7937C29.2728 33.4323 29.7126 33.8946 30.0047 33.9729L37.0541 29.2855L32.2393 47.2544C32.0514 47.9556 31.6053 47.8674 31.3628 47.0195L23.4839 20.3258C23.3223 19.7605 22.9796 18.4683 21.5771 18.0925Z"
        fill="#00C6A2"
        stroke="black"
      />
      <path
        d="M51.138 43.4681C46.4908 60.8118 34.6231 72.7011 24.6309 70.0237C22.9757 69.5802 18.6862 68.4308 18.6862 68.4308C31.2058 70.8159 41.8169 55.5106 45.6943 41.0399C49.6583 26.2461 46.5002 8.56733 35.2568 5.55469C35.2568 5.55469 39.991 6.82319 41.46 7.21681C51.4522 9.89422 55.7852 26.1245 51.138 43.4681Z"
        fill="white"
        stroke="black"
      />
      <path
        d="M18.6868 68.4311L24.6315 70.024C33.7388 72.4643 44.404 62.8037 49.7403 47.9418C49.7403 47.9418 48.6344 47.6454 47.0861 45.1529C45.5378 42.6604 45.6949 41.0402 45.6949 41.0402C41.8175 55.5109 31.2064 70.8162 18.6868 68.4311Z"
        fill="#00C6A2"
        stroke="black"
      />
      <path
        d="M18.6867 68.4311L24.6314 70.024C30.1321 71.4979 36.2011 68.5574 41.3211 62.7227C41.3211 62.7227 40.0597 61.5536 39.3721 59.9843C38.6845 58.4149 38.9364 56.4048 38.9364 56.4048C33.7653 64.3673 26.6081 69.9401 18.6867 68.4311Z"
        fill="black"
        stroke="black"
      />
      <path
        d="M19.4994 66.4332C28.3497 68.8046 39.0435 57.593 43.3847 41.3913C47.7259 25.1896 44.0706 10.1332 35.2204 7.76174L35.7744 5.69403C42.8915 7.04698 51.2006 20.4927 45.4524 41.9453C39.8428 62.8807 26.3369 70.897 18.9454 68.5009L19.4994 66.4332Z"
        fill="white"
      />
      <path
        d="M18.9463 68.5012C28.9386 71.1786 40.8062 59.2893 45.4534 41.9456C50.1006 24.602 45.7676 8.37174 35.7754 5.69434"
        stroke="black"
      />
      <path
        d="M19.4997 66.4332C28.35 68.8046 39.0438 57.5929 43.385 41.3913C47.7262 25.1896 44.071 10.1331 35.2207 7.76172"
        stroke="black"
      />
    </svg>
  );
};

const POOL_VE_PC = () => {
  return (
    <svg
      width="83"
      height="104"
      viewBox="0 0 83 104"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.3826 94.9266C39.399 98.6823 56.046 82.0048 62.5648 57.6764C69.0836 33.348 63.0056 10.5813 48.9892 6.82564C34.9729 3.06997 18.3258 19.7475 11.8071 44.0759C5.28828 68.4043 11.3663 91.171 25.3826 94.9266ZM26.1599 92.0263C38.5744 95.3528 53.5749 79.6259 59.6645 56.8994C65.754 34.1728 60.6266 13.0527 48.2121 9.72625C35.7976 6.39979 20.7971 22.1267 14.7076 44.8532C8.61802 67.5798 13.7454 88.6999 26.1599 92.0263Z"
        fill="white"
      />
      <path
        d="M62.0819 57.547C58.841 69.6421 53.0878 79.8113 46.4315 86.4798C39.7642 93.1593 32.2741 96.2556 25.5121 94.4437L25.2532 95.4096C32.5075 97.3534 40.3492 93.9888 47.1392 87.1863C53.9402 80.3729 59.7699 70.0391 63.0478 57.8058L62.0819 57.547ZM48.8598 7.30861C55.6219 9.1205 60.5604 15.547 62.9946 24.6652C65.4249 33.7685 65.3227 45.4519 62.0819 57.547L63.0478 57.8058C66.3257 45.5725 66.4439 33.7084 63.9608 24.4073C61.4817 15.1211 56.3729 8.28646 49.1186 6.34268L48.8598 7.30861ZM12.29 44.2053C15.5309 32.1102 21.2841 21.941 27.9404 15.2725C34.6077 8.59301 42.0978 5.49671 48.8598 7.30861L49.1186 6.34268C41.8644 4.3989 34.0227 7.76351 27.2327 14.566C20.4317 21.3794 14.602 31.7131 11.3241 43.9465L12.29 44.2053ZM25.5121 94.4437C18.75 92.6318 13.8115 86.2053 11.3773 77.0871C8.94696 67.9838 9.04915 56.3004 12.29 44.2053L11.3241 43.9465C8.04618 56.1798 7.92799 68.0439 10.4111 77.345C12.8902 86.6312 17.9989 93.4658 25.2532 95.4096L25.5121 94.4437ZM59.1815 56.77C56.1541 68.0682 50.9171 77.6024 44.9222 83.8876C38.9126 90.1883 32.2373 93.1371 26.2893 91.5434L26.0305 92.5093C32.497 94.242 39.5292 90.9906 45.6458 84.5778C51.7772 78.1496 57.0852 68.4571 60.1474 57.0288L59.1815 56.77ZM48.0827 10.2092C54.0308 11.803 58.3373 17.6944 60.3914 26.1557C62.4406 34.5964 62.2089 45.4717 59.1815 56.77L60.1474 57.0288C63.2096 45.6005 63.459 34.5525 61.3632 25.9198C59.2725 17.3079 54.808 10.976 48.3416 9.24328L48.0827 10.2092ZM15.1905 44.9826C18.2179 33.6843 23.4549 24.1502 29.4498 17.865C35.4595 11.5643 42.1347 8.61544 48.0827 10.2092L48.3416 9.24328C41.8751 7.5106 34.8428 10.762 28.7262 17.1748C22.5949 23.603 17.2868 33.2955 14.2246 44.7238L15.1905 44.9826ZM26.2893 91.5434C20.3413 89.9496 16.0348 84.0582 13.9806 75.5969C11.9315 67.1562 12.1632 56.2809 15.1905 44.9826L14.2246 44.7238C11.1624 56.1521 10.9131 67.2001 13.0088 75.8328C15.0996 84.4447 19.564 90.7766 26.0305 92.5093L26.2893 91.5434Z"
        fill="black"
      />
      <path
        d="M21.4146 46.6504C16.7028 64.2349 18.9085 90.0834 34.8501 91.4977C31.9097 92.5562 28.9684 92.7789 26.1596 92.0263C13.7451 88.6998 8.61772 67.5797 14.7073 44.8532C20.7968 22.1266 35.7973 6.39975 48.2118 9.72621C51.0207 10.4788 53.4565 12.1423 55.4738 14.5293C39.5213 10.2548 26.1263 29.0658 21.4146 46.6504Z"
        fill="white"
        stroke="black"
      />
      <path
        d="M55.4739 14.5296C53.4566 12.1427 51.0208 10.4792 48.212 9.72657C37.0106 6.72517 23.704 19.2353 16.7372 38.4029C16.7372 38.4029 17.3269 37.978 19.2463 40.2409C21.1658 42.5039 21.4147 46.6507 21.4147 46.6507C26.1265 29.0662 39.5215 10.2552 55.4739 14.5296Z"
        fill="#00C6A2"
        stroke="black"
      />
      <path
        d="M55.4746 14.5297C53.4573 12.1428 51.0215 10.4793 48.2127 9.72664C42.3381 8.15256 35.8845 10.8449 30.0701 16.5264C30.0701 16.5264 31.0807 17.7652 31.5047 20.5989C31.9287 23.4326 31.2486 25.9705 31.2486 25.9705C37.6131 17.4754 46.1025 12.0184 55.4746 14.5297Z"
        fill="black"
        stroke="black"
      />
      <path
        d="M25.3817 94.9272C39.3981 98.6828 56.0451 82.0053 62.5639 57.6769C69.0827 33.3485 63.0047 10.5818 48.9883 6.82617"
        stroke="black"
      />
      <path
        d="M26.1587 92.0267C38.5732 95.3531 53.5737 79.6262 59.6633 56.8997C65.7528 34.1731 60.6254 13.053 48.2109 9.72656"
        stroke="black"
      />
      <rect
        x="23.294"
        y="62.5689"
        width="7.25759"
        height="9.13503"
        transform="rotate(15 23.294 62.5689)"
        fill="white"
        stroke="black"
      />
      <rect
        x="28.4434"
        y="53.8756"
        width="7.25759"
        height="8.72963"
        transform="rotate(15 28.4434 53.8756)"
        fill="white"
        stroke="black"
      />
      <rect
        x="39.4239"
        y="25.7598"
        width="7.25759"
        height="28.9997"
        transform="rotate(15 39.4239 25.7598)"
        fill="white"
        stroke="black"
      />
      <rect
        x="28.0235"
        y="22.7051"
        width="5.65772"
        height="28.9997"
        transform="rotate(15 28.0235 22.7051)"
        fill="white"
        stroke="black"
      />
      <path
        d="M29.0401 40.7698C29.0391 40.767 29.038 40.7642 29.037 40.7613C28.6823 39.7797 28.1172 38.5238 27.2831 37.5159C26.4755 36.54 25.7467 35.9051 25.2108 35.5103C25.0054 35.359 24.8285 35.2431 24.6867 35.157L27.9707 22.9009L33.4357 24.3653L29.0401 40.7698Z"
        fill="black"
        stroke="black"
      />
      <path
        d="M33.6037 62.6583C33.5486 62.5228 33.4887 62.3816 33.4235 62.2356C32.9009 61.0646 32.0358 59.5703 30.6697 58.3216C29.3497 57.115 28.4683 56.6243 27.8678 56.4634C27.83 56.4532 27.7931 56.4444 27.7571 56.4367L28.4434 53.8756L35.4537 55.754L33.6037 62.6583Z"
        fill="black"
        stroke="black"
      />
      <path
        d="M44.0572 36.5051C44.0032 36.3689 43.9444 36.227 43.8805 36.0804C43.3629 34.8927 42.5038 33.3771 41.1414 32.1132C39.8254 30.8923 38.9442 30.3962 38.3415 30.2347C38.3038 30.2246 38.2669 30.2157 38.2309 30.2081L39.4151 25.7886L46.4254 27.667L44.0572 36.5051Z"
        fill="black"
        stroke="black"
      />
      <path
        d="M29.355 67.9902C29.2653 67.8736 29.1655 67.749 29.0552 67.6182C28.4125 66.8559 27.4113 65.8784 25.9677 64.9991C24.5585 64.1406 23.6795 63.7719 23.1289 63.6244C23.0909 63.6142 23.0541 63.605 23.0186 63.5967L23.294 62.5689L30.3043 64.4473L29.355 67.9902Z"
        fill="black"
        stroke="black"
      />
      <path
        d="M17.5458 50.1211L14.6209 49.3373L22.1768 21.1383L27.3404 22.5218L19.8007 50.6607L19.6713 51.1436L20.1542 51.2731L25.7769 52.7796L26.2599 52.9091L26.3893 52.4261L33.9291 24.2873L38.7496 25.5789L31.1937 53.778L28.4325 53.0381L27.9495 52.9087L27.8201 53.3917L25.4365 62.2875L23.307 61.7169L22.824 61.5874L22.6946 62.0704L20.2459 71.209L16.0103 70.074L18.459 60.9355L18.5884 60.4525L18.1054 60.3231L15.5158 59.6292L17.8994 50.7334L18.0288 50.2505L17.5458 50.1211Z"
        fill="#00C6A2"
        stroke="black"
      />
      <rect
        x="46.9707"
        y="68.9132"
        width="7.25759"
        height="9.13503"
        transform="rotate(15 46.9707 68.9132)"
        fill="white"
        stroke="black"
      />
      <rect
        x="57.3584"
        y="30.1461"
        width="7.25759"
        height="9.13503"
        transform="rotate(15 57.3584 30.1461)"
        fill="white"
        stroke="black"
      />
      <rect
        x="43.1514"
        y="56.9776"
        width="7.25759"
        height="9.94583"
        transform="rotate(15 43.1514 56.9776)"
        fill="white"
        stroke="black"
      />
      <rect
        x="48.1162"
        y="37.7432"
        width="7.25759"
        height="9.94583"
        transform="rotate(15 48.1162 37.7432)"
        fill="white"
        stroke="black"
      />
      <path
        d="M53.2081 46.7845C53.1415 46.6571 53.0686 46.5229 52.9892 46.3829C52.4204 45.3793 51.5136 44.0717 50.1606 42.8565C48.836 41.6668 47.9544 41.1823 47.3563 41.0221C47.3185 41.012 47.2817 41.0031 47.2457 40.9954L48.1172 37.7427L55.1275 39.6211L53.2081 46.7845Z"
        fill="black"
        stroke="black"
      />
      <path
        d="M48.1368 66.4114C48.0702 66.284 47.9973 66.1498 47.918 66.0098C47.3491 65.0063 46.4423 63.6987 45.0893 62.4835C43.7647 61.2938 42.8832 60.8093 42.285 60.649C42.2472 60.6389 42.2104 60.63 42.1744 60.6223L43.0459 57.3697L50.0562 59.2481L48.1368 66.4114Z"
        fill="black"
        stroke="black"
      />
      <rect
        x="52.1133"
        y="49.7257"
        width="7.25759"
        height="8.72963"
        transform="rotate(15 52.1133 49.7257)"
        fill="white"
        stroke="black"
      />
      <path
        d="M52.9408 75.0382C52.8554 74.9204 52.7609 74.7945 52.6568 74.6619C52.0295 73.8626 51.0538 72.817 49.6518 71.8148C48.2775 70.8324 47.4179 70.3937 46.8774 70.2058C46.8276 70.1885 46.78 70.1731 46.7344 70.1595L47.0616 68.9385L54.0719 70.8169L52.9408 75.0382Z"
        fill="black"
        stroke="black"
      />
      <path
        d="M40.1939 67.1538L46.2834 68.7855L43.9333 77.5565L31.7452 74.2907L44.4971 26.6998L56.6852 29.9656L54.3483 38.6871L48.2588 37.0554L47.7758 36.926L47.6464 37.409L44.9634 47.4219L44.834 47.9048L45.317 48.0342L51.4065 49.6659L49.1502 58.0868L43.0606 56.4551L42.5777 56.3257L42.4483 56.8087L39.8404 66.5415L39.711 67.0244L40.1939 67.1538Z"
        fill="#00C6A2"
        stroke="black"
      />
      <path
        d="M70.5396 59.8141C64.0208 84.1425 47.3738 100.82 33.3574 97.0644C31.0357 96.4422 25.0187 94.83 25.0187 94.83C42.5802 98.1755 57.4646 76.7065 62.9036 56.408C68.464 35.6562 64.034 10.8578 48.2627 6.63184C48.2627 6.63184 54.9034 8.4112 56.964 8.96335C70.9804 12.719 77.0584 35.4857 70.5396 59.8141Z"
        fill="white"
        stroke="black"
      />
      <path
        d="M25.0198 94.8302L33.3585 97.0646C46.1336 100.488 61.094 86.9365 68.5793 66.0892C68.5793 66.0892 67.028 65.6735 64.8562 62.1772C62.6843 58.6808 62.9047 56.4082 62.9047 56.4082C57.4658 76.7067 42.5814 98.1757 25.0198 94.8302Z"
        fill="#00C6A2"
        stroke="black"
      />
      <path
        d="M25.0195 94.8296L33.3582 97.064C41.0742 99.1315 49.5874 95.0067 56.7693 86.8222C56.7693 86.8222 54.9999 85.1824 54.0354 82.981C53.0709 80.7796 53.4242 77.9599 53.4242 77.9599C46.1706 89.1292 36.1309 96.9464 25.0195 94.8296Z"
        fill="black"
        stroke="black"
      />
      <path
        d="M26.1588 92.0269C38.5733 95.3534 53.5738 79.6265 59.6634 56.8999C65.753 34.1734 60.6256 13.0533 48.2111 9.72682L48.9883 6.82637C58.9716 8.7242 70.627 27.5849 62.5639 57.6771C54.6951 87.0437 35.7501 98.2884 25.3817 94.9273L26.1588 92.0269Z"
        fill="white"
      />
      <path
        d="M25.3817 94.9276C39.3981 98.6833 56.0451 82.0058 62.5639 57.6774C69.0827 33.349 63.0047 10.5823 48.9883 6.82666"
        stroke="black"
      />
      <path
        d="M26.1597 92.0271C38.5742 95.3536 53.5747 79.6267 59.6642 56.9002C65.7538 34.1736 60.6264 13.0535 48.2119 9.72705"
        stroke="black"
      />
    </svg>
  );
};

const POOL_LOVE_PC = () => {
  return (
    <svg
      width="83"
      height="104"
      viewBox="0 0 83 104"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.8797 94.9266C39.8961 98.6823 56.5431 82.0048 63.0619 57.6764C69.5807 33.348 63.5027 10.5813 49.4863 6.82564C35.4699 3.06997 18.8229 19.7475 12.3041 44.0759C5.78535 68.4043 11.8633 91.171 25.8797 94.9266ZM26.657 92.0263C39.0715 95.3528 54.072 79.6259 60.1615 56.8994C66.2511 34.1728 61.1237 13.0527 48.7092 9.72625C36.2947 6.39979 21.2942 22.1267 15.2047 44.8532C9.11509 67.5798 14.2425 88.6999 26.657 92.0263Z"
        fill="white"
      />
      <path
        d="M62.5789 57.547C59.3381 69.6421 53.5849 79.8113 46.9285 86.4798C40.2613 93.1593 32.7712 96.2556 26.0091 94.4437L25.7503 95.4096C33.0046 97.3534 40.8462 93.9888 47.6363 87.1863C54.4373 80.3729 60.2669 70.0391 63.5449 57.8058L62.5789 57.547ZM49.3569 7.30861C56.119 9.1205 61.0574 15.547 63.4917 24.6652C65.922 33.7685 65.8198 45.4519 62.5789 57.547L63.5449 57.8058C66.8228 45.5725 66.941 33.7084 64.4579 24.4073C61.9787 15.1211 56.87 8.28646 49.6157 6.34268L49.3569 7.30861ZM12.7871 44.2053C16.028 32.1102 21.7812 21.941 28.4375 15.2725C35.1047 8.59301 42.5948 5.49671 49.3569 7.30861L49.6157 6.34268C42.3614 4.3989 34.5198 7.76351 27.7297 14.566C20.9288 21.3794 15.0991 31.7131 11.8212 43.9465L12.7871 44.2053ZM26.0091 94.4437C19.2471 92.6318 14.3086 86.2053 11.8743 77.0871C9.44403 67.9838 9.54622 56.3004 12.7871 44.2053L11.8212 43.9465C8.54325 56.1798 8.42506 68.0439 10.9082 77.345C13.3873 86.6312 18.496 93.4658 25.7503 95.4096L26.0091 94.4437ZM59.6786 56.77C56.6512 68.0682 51.4142 77.6024 45.4193 83.8876C39.4096 90.1883 32.7344 93.1372 26.7864 91.5434L26.5276 92.5093C32.994 94.242 40.0263 90.9906 46.1429 84.5778C52.2743 78.1496 57.5823 68.4571 60.6445 57.0288L59.6786 56.77ZM48.5798 10.2092C54.5278 11.803 58.8343 17.6944 60.8885 26.1557C62.9377 34.5964 62.7059 45.4717 59.6786 56.77L60.6445 57.0288C63.7067 45.6005 63.9561 34.5525 61.8603 25.9198C59.7695 17.3079 55.3051 10.976 48.8386 9.24328L48.5798 10.2092ZM15.6876 44.9826C18.715 33.6843 23.952 24.1502 29.9469 17.865C35.9566 11.5643 42.6318 8.61544 48.5798 10.2092L48.8386 9.24328C42.3722 7.5106 35.3399 10.762 29.2233 17.1748C23.0919 23.603 17.7839 33.2955 14.7217 44.7238L15.6876 44.9826ZM26.7864 91.5434C20.8384 89.9496 16.5319 84.0582 14.4777 75.5969C12.4285 67.1562 12.6603 56.2809 15.6876 44.9826L14.7217 44.7238C11.6595 56.1521 11.4101 67.2001 13.5059 75.8328C15.5966 84.4447 20.0611 90.7766 26.5276 92.5093L26.7864 91.5434Z"
        fill="black"
      />
      <path
        d="M21.9126 46.6504C17.2008 64.2349 19.4065 90.0834 35.3482 91.4977C32.4077 92.5562 29.4665 92.7789 26.6576 92.0263C14.2431 88.6998 9.11576 67.5797 15.2053 44.8532C21.2949 22.1266 36.2954 6.39975 48.7099 9.72621C51.5187 10.4788 53.9545 12.1423 55.9718 14.5293C40.0194 10.2548 26.6244 29.0658 21.9126 46.6504Z"
        fill="white"
        stroke="black"
      />
      <path
        d="M55.9719 14.5296C53.9547 12.1427 51.5189 10.4792 48.71 9.72657C37.5087 6.72517 24.202 19.2353 17.2352 38.4029C17.2352 38.4029 17.8249 37.978 19.7444 40.2409C21.6638 42.5039 21.9127 46.6507 21.9127 46.6507C26.6245 29.0662 40.0195 10.2552 55.9719 14.5296Z"
        fill="#00C6A2"
        stroke="black"
      />
      <path
        d="M55.9726 14.5292C53.9554 12.1423 51.5196 10.4788 48.7107 9.72615C42.8362 8.15207 36.3826 10.8444 30.5681 16.5259C30.5681 16.5259 31.5787 17.7647 32.0027 20.5984C32.4267 23.4321 31.7467 25.97 31.7467 25.97C38.1111 17.4749 46.6005 12.018 55.9726 14.5292Z"
        fill="black"
        stroke="black"
      />
      <path
        d="M25.8807 94.9272C39.8971 98.6828 56.5441 82.0053 63.0629 57.6769C69.5817 33.3485 63.5037 10.5818 49.4873 6.82617"
        stroke="black"
      />
      <path
        d="M26.6577 92.0267C39.0722 95.3531 54.0727 79.6262 60.1623 56.8997C66.2518 34.1731 61.1245 13.053 48.71 9.72656"
        stroke="black"
      />
      <rect
        x="35.3291"
        y="20.2397"
        width="6.01594"
        height="7.5069"
        transform="rotate(15 35.3291 20.2397)"
        fill="white"
        stroke="black"
      />
      <path
        d="M35.6695 19.8127L29.09 18.0497C28.825 17.9787 28.5441 17.9798 28.2961 18.0672C28.049 18.1543 27.7918 18.3482 27.7041 18.6758L25.9194 25.3362C25.8818 25.3437 25.8194 25.3462 25.7395 25.3248L23.5964 24.7506C23.3314 24.6796 23.0504 24.6807 22.8025 24.7681C22.5553 24.8551 22.2982 25.0491 22.2104 25.3767L20.4572 31.9197C20.4196 31.9272 20.3572 31.9297 20.2773 31.9083L17.2662 31.1015C17.0012 31.0304 16.7202 31.0316 16.4723 31.1189C16.2251 31.206 15.968 31.3999 15.8802 31.7275L13.7288 39.7566C13.641 40.0842 13.7668 40.3808 13.9372 40.5797C14.1083 40.7793 14.3511 40.9208 14.6161 40.9918L17.6272 41.7986C17.7071 41.82 17.7599 41.8535 17.7887 41.8787L15.9568 48.7153C15.869 49.0429 15.9948 49.3395 16.1653 49.5384C16.3363 49.738 16.5791 49.8795 16.8441 49.9505L18.9872 50.5247C19.0671 50.5461 19.1199 50.5796 19.1487 50.6048L17.427 57.0304C17.3392 57.358 17.4649 57.6546 17.6354 57.8535C17.8065 58.0531 18.0492 58.1946 18.3142 58.2656L21.1539 59.0265C21.2338 59.0479 21.2866 59.0813 21.3154 59.1066L19.5622 65.6495C19.4744 65.9772 19.6002 66.2737 19.7706 66.4727C19.9417 66.6723 20.1845 66.8137 20.4495 66.8848L22.5926 67.459C22.6725 67.4804 22.7253 67.5138 22.7541 67.5391L20.9694 74.1995C20.8817 74.5271 21.0074 74.8237 21.1779 75.0226C21.3489 75.2222 21.5917 75.3637 21.8567 75.4347L25.6393 76.4483C25.9043 76.5193 26.1853 76.5181 26.4332 76.4308C26.6804 76.3437 26.9375 76.1498 27.0253 75.8222L28.81 69.1618C28.8475 69.1543 28.91 69.1517 28.9899 69.1731L30.9616 69.7015C31.2266 69.7725 31.5075 69.7713 31.7555 69.684C32.0026 69.5969 32.2598 69.403 32.3476 69.0754L34.1007 62.5324C34.1383 62.5249 34.2008 62.5224 34.2806 62.5438L37.1203 63.3047C37.3853 63.3757 37.6663 63.3745 37.9142 63.2872C38.1613 63.2001 38.4185 63.0062 38.5063 62.6786L40.228 56.253C40.2656 56.2455 40.328 56.243 40.4079 56.2644L43.1618 57.0023C43.4268 57.0733 43.7078 57.0722 43.9558 56.9849C44.2029 56.8978 44.46 56.7039 44.5478 56.3762L46.3797 49.5397C46.4172 49.5322 46.4797 49.5297 46.5596 49.5511L48.7027 50.1253C48.9677 50.1963 49.2487 50.1952 49.4966 50.1079C49.7438 50.0208 50.0009 49.8268 50.0887 49.4992L52.2401 41.4702C52.3279 41.1425 52.2021 40.846 52.0317 40.647C51.8606 40.4474 51.6178 40.306 51.3528 40.2349L49.2097 39.6607C49.1298 39.6393 49.077 39.6059 49.0482 39.5806L50.8486 32.8615C50.9364 32.5339 50.8106 32.2373 50.6402 32.0384C50.4691 31.8388 50.2263 31.6973 49.9613 31.6263L47.2074 30.8884C47.1275 30.867 47.0747 30.8335 47.0459 30.8083L48.7834 24.324C48.8712 23.9964 48.7454 23.6998 48.5749 23.5009C48.4039 23.3013 48.1611 23.1598 47.8961 23.0888L42.2918 21.5871C42.0268 21.5161 41.7458 21.5172 41.4979 21.6046C41.2508 21.6917 40.9936 21.8856 40.9058 22.2132L39.1684 28.6975C39.1308 28.705 39.0683 28.7075 38.9885 28.6861L34.9808 27.6122C34.9009 27.5908 34.8481 27.5574 34.8193 27.5322L36.5567 21.0479C36.6445 20.7203 36.5188 20.4237 36.3483 20.2248C36.1773 20.0252 35.9345 19.8837 35.6695 19.8127Z"
        fill="#00C6A2"
        stroke="black"
      />
      <path
        d="M48.5722 24.2675C48.6391 24.018 48.4515 23.561 48.0871 23.4634L56.0167 25.5882C56.5502 25.7311 56.8668 26.2794 56.7239 26.8129L54.9853 33.3014L57.8829 34.0778C58.4164 34.2207 58.7332 34.7684 58.5902 35.3019L56.8147 41.9283L59.2831 42.5897C59.8166 42.7326 60.1326 43.2808 59.9896 43.8143L57.9814 51.3089C57.8385 51.8423 57.2902 52.1589 56.7567 52.016L54.2889 51.3547L52.4591 58.1837C52.3161 58.7172 51.7678 59.0338 51.2343 58.8908L47.9741 58.0173L46.2414 64.4837C46.0985 65.0172 45.5501 65.3338 45.0167 65.1908L41.8019 64.3295L40.0693 70.7959C39.9263 71.3294 39.378 71.646 38.8445 71.503L36.6189 70.9067L34.8376 77.5544C34.6947 78.0879 34.1464 78.4045 33.6129 78.2615L25.992 76.2195C26.3564 76.3171 26.7473 76.0152 26.8142 75.7657L28.5886 69.1435C28.6555 68.894 28.9884 68.8621 29.3528 68.9597L31.3111 69.4845C31.6754 69.5821 32.0436 69.3653 32.1105 69.1158L33.9083 62.4063C33.9751 62.1568 34.2456 62.3047 34.6099 62.4024L37.4496 63.1632C37.8139 63.2609 38.2283 62.8716 38.2952 62.6221L40.0356 56.1269C40.1024 55.8774 40.3841 55.9835 40.7484 56.0811L43.5023 56.8191C43.8667 56.9167 44.2699 56.5693 44.3367 56.3197L46.1872 49.4136C46.2541 49.164 46.534 49.2768 46.8983 49.3744L49.0414 49.9487C49.4058 50.0463 49.8107 49.6923 49.8776 49.4427L52.029 41.4137C52.0958 41.1641 51.7854 40.5807 51.4211 40.4831L49.5421 39.9796C49.1777 39.882 48.7516 39.8433 48.8184 39.5938L50.6375 32.805C50.7043 32.5555 50.772 32.1724 50.4076 32.0748L47.3861 31.2416C47.1219 31.1708 46.7493 31.071 46.8161 30.8214L48.5722 24.2675Z"
        fill="white"
      />
      <path
        d="M50.4076 32.0748L47.3861 31.2416C47.1219 31.1708 46.7493 31.071 46.8161 30.8214L48.5722 24.2675C48.6391 24.018 48.4515 23.561 48.0871 23.4634L56.0167 25.5882C56.5502 25.7311 56.8668 26.2794 56.7239 26.8129L54.9853 33.3014M50.4076 32.0748C50.772 32.1724 50.7043 32.5555 50.6375 32.805L48.8184 39.5938C48.7516 39.8433 49.1777 39.882 49.5421 39.9796C49.5421 39.9796 50.5841 40.2588 51.4211 40.4831M50.4076 32.0748L54.9853 33.3014M51.4211 40.4831C51.7854 40.5807 52.0958 41.1641 52.029 41.4137L49.8776 49.4427C49.8107 49.6923 49.4058 50.0463 49.0414 49.9487M51.4211 40.4831L56.8147 41.9283M49.0414 49.9487L46.8983 49.3744C46.534 49.2768 46.2541 49.164 46.1872 49.4136L44.3367 56.3197C44.2699 56.5693 43.8667 56.9167 43.5023 56.8191M49.0414 49.9487L54.2889 51.3547M43.5023 56.8191L40.7484 56.0812C40.3841 55.9835 40.1024 55.8774 40.0356 56.1269L38.2952 62.6221C38.2283 62.8716 37.8139 63.2609 37.4496 63.1632M43.5023 56.8191L47.9741 58.0173M37.4496 63.1632L34.6099 62.4024C34.2456 62.3047 33.9751 62.1568 33.9083 62.4063L32.1105 69.1158C32.0436 69.3653 31.6754 69.5821 31.3111 69.4845M37.4496 63.1632L41.8019 64.3295M31.3111 69.4845L29.3528 68.9597C28.9884 68.8621 28.6555 68.894 28.5886 69.1435L26.8142 75.7657C26.7473 76.0152 26.3564 76.3171 25.992 76.2195L33.6129 78.2615C34.1464 78.4045 34.6947 78.0879 34.8376 77.5544L36.6189 70.9067M31.3111 69.4845L36.6189 70.9067M54.9853 33.3014L57.8829 34.0778C58.4164 34.2207 58.7332 34.7684 58.5902 35.3019C58.1775 36.8422 57.3609 39.8898 56.8147 41.9283M56.8147 41.9283C57.6566 42.1539 58.5989 42.4064 59.2831 42.5897C59.8166 42.7326 60.1326 43.2808 59.9896 43.8143L57.9814 51.3089C57.8385 51.8423 57.2902 52.1589 56.7567 52.016L54.2889 51.3547M54.2889 51.3547L52.459 58.1837C52.3161 58.7172 51.7678 59.0338 51.2343 58.8908L47.9741 58.0173M47.9741 58.0173L46.2414 64.4837C46.0985 65.0172 45.5501 65.3338 45.0167 65.1908L41.8019 64.3295M41.8019 64.3295L40.0693 70.7959C39.9263 71.3294 39.378 71.646 38.8445 71.503L36.6189 70.9067"
        stroke="black"
      />
      <path
        d="M46.4258 61.6303C46.416 61.6147 46.406 61.5991 46.3959 61.5833C45.905 60.8194 45.0709 59.8709 43.6936 59.0898C42.3593 58.333 41.2974 57.9453 40.5571 57.747C40.3387 57.6884 40.1484 57.6465 39.9878 57.6163L40.293 56.4771L47.3033 58.3555L46.4258 61.6303Z"
        fill="black"
        stroke="black"
      />
      <path
        d="M52.7891 54.786C52.7793 54.7705 52.7693 54.7548 52.7592 54.7391C52.2683 53.9752 51.4342 53.0267 50.0569 52.2455C48.7225 51.4887 47.6607 51.1011 46.9204 50.9027C46.702 50.8442 46.5117 50.8022 46.351 50.7721L46.5269 50.1158C46.5983 49.8491 46.8725 49.6908 47.1393 49.7623L53.6666 51.5113L52.7891 54.786Z"
        fill="black"
        stroke="black"
      />
      <path
        d="M39.5513 25.7991C39.0494 26.1492 38.4094 26.4657 37.6459 26.5805C36.655 26.7294 35.9369 26.6514 35.4487 26.5206C35.3995 26.5074 35.3528 26.4937 35.3085 26.4797L35.1373 27.1186C35.0658 27.3853 35.2241 27.6595 35.4908 27.7309L38.7964 28.6166L39.5513 25.7991Z"
        fill="black"
        stroke="black"
      />
      <path
        d="M40.1783 68.0418C40.1716 68.0304 40.1648 68.019 40.158 68.0075C39.6796 67.2035 38.858 66.2048 37.4836 65.3935C36.1543 64.6089 35.0916 64.2132 34.3483 64.0141C34.1301 63.9556 33.9398 63.9141 33.7785 63.8848L34.1241 62.5953L41.1344 64.4737L40.1783 68.0418Z"
        fill="black"
        stroke="black"
      />
      <path
        d="M34.9693 74.8065C34.9626 74.7951 34.9558 74.7836 34.949 74.7721C34.4706 73.9681 33.649 72.9694 32.2746 72.1582C30.9453 71.3736 29.8826 70.9779 29.1393 70.7787C28.9212 70.7203 28.7308 70.6788 28.5696 70.6494L28.7857 69.8429C28.8571 69.5762 29.1313 69.4179 29.398 69.4893L35.9254 71.2383L34.9693 74.8065Z"
        fill="black"
        stroke="black"
      />
      <path
        d="M71.0386 59.8141C64.5199 84.1425 47.8728 100.82 33.8565 97.0644C31.5347 96.4422 25.5177 94.83 25.5177 94.83C43.0793 98.1755 57.9637 76.7065 63.4026 56.408C68.963 35.6562 64.5331 10.8578 48.7617 6.63184C48.7617 6.63184 55.4024 8.4112 57.463 8.96335C71.4794 12.719 77.5574 35.4857 71.0386 59.8141Z"
        fill="white"
        stroke="black"
      />
      <path
        d="M25.5178 94.8297L33.8566 97.0641C46.6316 100.487 61.592 86.936 69.0773 66.0887C69.0773 66.0887 67.5261 65.673 65.3542 62.1767C63.1824 58.6804 63.4028 56.4077 63.4028 56.4077C57.9638 76.7062 43.0794 98.1753 25.5178 94.8297Z"
        fill="#00C6A2"
        stroke="black"
      />
      <path
        d="M25.5175 94.8301L33.8563 97.0645C41.5723 99.1319 50.0854 95.0072 57.2673 86.8227C57.2673 86.8227 55.498 85.1829 54.5335 82.9815C53.569 80.7801 53.9223 77.9604 53.9223 77.9604C46.6687 89.1297 36.629 96.9469 25.5175 94.8301Z"
        fill="black"
        stroke="black"
      />
      <path
        d="M26.6579 92.0264C39.0724 95.3529 54.0729 79.626 60.1624 56.8995C66.252 34.1729 61.1246 13.0528 48.7101 9.72633L49.4873 6.82589C59.4706 8.72371 71.1261 27.5844 63.0629 57.6766C55.1941 87.0432 36.2491 98.2879 25.8807 94.9269L26.6579 92.0264Z"
        fill="white"
      />
      <path
        d="M25.8817 94.9272C39.8981 98.6828 56.5451 82.0053 63.0639 57.6769C69.5827 33.3485 63.5047 10.5818 49.4883 6.82617"
        stroke="black"
      />
      <path
        d="M26.6577 92.0267C39.0722 95.3531 54.0727 79.6262 60.1623 56.8997C66.2518 34.1731 61.1245 13.053 48.71 9.72656"
        stroke="black"
      />
    </svg>
  );
};

const DASH = () => {
  return (
    <svg
      width="137"
      height="25"
      viewBox="0 0 137 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 15.0594H16.8764L20.4509 7.70404L25.6025 23.1609L32.5414 2.16089L35.8005 15.0594H136.5"
        stroke="url(#paint0_linear_4728_7507)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_4728_7507"
          x1="0.449275"
          y1="16.3131"
          x2="82.6667"
          y2="16.7552"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00FFD1" />
          <stop offset="1" stop-color="#00FFD1" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const BG_RECTANGLE = () => {
  return (
    <svg
      width="591"
      height="106"
      viewBox="0 0 591 106"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_4728_7506)">
        <path
          d="M571 32C571 25.3726 565.627 20 559 20H89.464C67.1164 20 46.687 32.6261 36.6928 52.6144L20 86H559C565.627 86 571 80.6274 571 74V32Z"
          fill="url(#paint0_linear_4728_7506)"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_4728_7506"
          x="0"
          y="0"
          width="591"
          height="106"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="10"
            operator="dilate"
            in="SourceAlpha"
            result="effect1_dropShadow_4728_7506"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4728_7506"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4728_7506"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_4728_7506"
          x1="311.168"
          y1="65.8913"
          x2="-45.2193"
          y2="65.8914"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1D2932" />
          <stop offset="1" stopColor="#00C6A2" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const PoolDaoBanner = () => {
  return (
    <div className="relative">
      <div
        className="z-10 absolute -right-5 "
        style={{
          top: '18px',
        }}
      >
        <BG_RECTANGLE />
      </div>

      <div className="relative z-20 top-2.5 flex items-center">
        <span className="left-2 top-2 relative z-30">
          <POOL_REF_PC />
        </span>
        <span className="relative right-3 top-1 z-20">
          <POOL_NEAR_PC />
        </span>

        <span className="left-7 relative z-20">
          <POOL_VE_PC />
        </span>

        <span className="z-20 relative left-4">
          <POOL_LOVE_PC />
        </span>

        <span className="absolute left-24 z-10">
          <DASH />
        </span>
      </div>
    </div>
  );
};

const POOL_DAO_ICONS_MOBILE = () => {
  return (
    <svg
      width="267"
      height="117"
      viewBox="0 0 267 117"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.4064 98.263C36.3161 100.29 46.4729 86.4051 52.0922 67.2501C57.7115 48.0952 56.6654 30.9238 49.7558 28.8968C42.8461 26.8697 32.6893 40.7547 27.07 59.9096C21.4507 79.0646 22.4968 96.236 29.4064 98.263ZM30.1751 95.5794C35.9837 97.2835 44.9081 84.295 50.1082 66.5688C55.3084 48.8427 54.8151 33.0914 49.0065 31.3874C43.1979 29.6833 34.2735 42.6718 29.0733 60.398C23.8732 78.1241 24.3664 93.8754 30.1751 95.5794Z"
        fill="white"
      />
      <path
        d="M52.0922 67.2501L51.6124 67.1094L52.0922 67.2501ZM29.4064 98.263L29.5472 97.7832L29.5472 97.7832L29.4064 98.263ZM49.7558 28.8968L49.8965 28.417L49.8965 28.417L49.7558 28.8968ZM27.07 59.9096L27.5498 60.0504L27.07 59.9096ZM50.1082 66.5688L50.588 66.7096L50.1082 66.5688ZM30.1751 95.5794L30.0343 96.0592L30.1751 95.5794ZM49.0065 31.3874L48.8657 31.8671L49.0065 31.3874ZM29.0733 60.398L28.5935 60.2572L29.0733 60.398ZM51.6124 67.1094C48.8146 76.6463 44.8927 84.8502 40.8296 90.4046C38.7968 93.1836 36.7452 95.2765 34.8022 96.5476C32.857 97.8201 31.0806 98.233 29.5472 97.7832L29.2657 98.7428C31.1871 99.3064 33.2714 98.7439 35.3496 97.3845C37.4299 96.0236 39.5643 93.8282 41.6368 90.995C45.7843 85.325 49.7504 77.0089 52.572 67.3909L51.6124 67.1094ZM49.615 29.3766C51.1484 29.8264 52.4202 31.1336 53.3697 33.2552C54.3181 35.3745 54.9139 38.2441 55.1233 41.6809C55.5417 48.55 54.4102 57.5725 51.6124 67.1094L52.572 67.3909C55.3935 57.7729 56.5486 48.6322 56.1214 41.6201C55.908 38.1163 55.2979 35.1157 54.2824 32.8467C53.2681 30.58 51.818 28.9807 49.8965 28.417L49.615 29.3766ZM27.5498 60.0504C30.3476 50.5134 34.2695 42.3096 38.3326 36.7552C40.3654 33.9761 42.417 31.8832 44.36 30.6121C46.3052 29.3397 48.0816 28.9267 49.615 29.3766L49.8965 28.417C47.9751 27.8533 45.8908 28.4158 43.8126 29.7753C41.7323 31.1361 39.5979 33.3316 37.5254 36.1648C33.3779 41.8348 29.4118 50.1508 26.5902 59.7689L27.5498 60.0504ZM29.5472 97.7832C28.0138 97.3334 26.742 96.0262 25.7925 93.9045C24.8441 91.7852 24.2483 88.9157 24.0389 85.4789C23.6205 78.6098 24.752 69.5873 27.5498 60.0504L26.5902 59.7689C23.7687 69.3869 22.6136 78.5276 23.0408 85.5397C23.2542 89.0435 23.8643 92.044 24.8798 94.313C25.8941 96.5797 27.3442 98.1791 29.2657 98.7428L29.5472 97.7832ZM49.6284 66.4281C47.0391 75.2546 43.5276 82.8817 39.9577 88.0773C38.1712 90.6774 36.3864 92.6444 34.7158 93.853C33.0384 95.0666 31.5544 95.463 30.3158 95.0997L30.0343 96.0592C31.7 96.5479 33.5098 95.9598 35.3019 94.6632C37.1008 93.3618 38.9613 91.2933 40.7819 88.6436C44.4264 83.3394 47.9772 75.6092 50.588 66.7096L49.6284 66.4281ZM48.8657 31.8671C50.1043 32.2305 51.139 33.3658 51.8949 35.2932C52.6479 37.2127 53.0871 39.8322 53.1859 42.9854C53.3832 49.2862 52.2178 57.6015 49.6284 66.4281L50.588 66.7096C53.1988 57.8099 54.3868 49.3866 54.1854 42.9541C54.0848 39.7408 53.6366 36.995 52.8259 34.928C52.0182 32.8688 50.813 31.3962 49.1472 30.9076L48.8657 31.8671ZM29.5531 60.5387C32.1425 51.7122 35.654 44.0851 39.2238 38.8895C41.0104 36.2894 42.7952 34.3223 44.4658 33.1137C46.1431 31.9002 47.6272 31.5038 48.8657 31.8671L49.1472 30.9076C47.4815 30.4189 45.6717 31.007 43.8796 32.3035C42.0807 33.605 40.2203 35.6735 38.3996 38.3232C34.7551 43.6274 31.2043 51.3576 28.5935 60.2572L29.5531 60.5387ZM30.3158 95.0997C29.0772 94.7363 28.0426 93.601 27.2866 91.6736C26.5337 89.7541 26.0944 87.1346 25.9956 83.9814C25.7983 77.6806 26.9637 69.3653 29.5531 60.5387L28.5935 60.2572C25.9827 69.1569 24.7947 77.5802 24.9961 84.0127C25.0968 87.226 25.5449 89.9718 26.3556 92.0388C27.1633 94.098 28.3686 95.5706 30.0343 96.0592L30.3158 95.0997Z"
        fill="black"
      />
      <path
        d="M34.2769 61.9489C30.3135 73.9211 29.4632 84.438 31.9034 92.0797C32.5146 94.8769 34.0691 94.8667 34.0691 94.8667C32.6795 95.6614 31.3618 95.9271 30.1743 95.5788C24.3657 93.8747 23.8724 78.1235 29.0726 60.3973C34.2727 42.6712 43.1971 29.6827 49.0057 31.3867C50.1691 31.728 51.1193 32.6327 51.8532 34.004C51.8532 34.004 41.6845 36.2619 34.2769 61.9489Z"
        fill="white"
        stroke="black"
      />
      <path
        d="M51.8536 34.0046C51.1197 32.6333 50.1696 31.7285 49.0062 31.3872C43.8101 29.8629 36.1208 40.0957 30.8344 54.9597C32.5745 55.4743 34.2774 61.9495 34.2774 61.9495C34.2774 61.9495 35.0988 59.2006 35.5198 57.9285C42.7704 36.0214 51.8536 34.0046 51.8536 34.0046Z"
        fill="#00C6A2"
        stroke="black"
      />
      <path
        d="M51.8548 34.0041C51.1209 32.6328 50.1707 31.728 49.0073 31.3867C46.2444 30.5762 42.7766 33.0898 39.34 37.8562C39.34 37.8562 40.296 38.5015 40.9384 40.8383C41.5809 43.1752 40.9279 45.3079 40.9279 45.3079C46.621 35.1662 51.8548 34.0041 51.8548 34.0041Z"
        fill="black"
        stroke="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M66.5226 97.7552C73.4323 99.7822 83.5891 85.8973 89.2084 66.7423C94.8277 47.5874 93.7817 30.416 86.872 28.389C79.9623 26.3619 69.8055 40.2469 64.1862 59.4018C58.5669 78.5568 59.613 95.7281 66.5226 97.7552ZM67.2905 95.0712C73.0991 96.7753 82.0235 83.7868 87.2237 66.0606C92.4238 48.3345 91.9306 32.5832 86.1219 30.8792C80.3133 29.1751 71.3889 42.1636 66.1888 59.8898C60.9886 77.6159 61.4819 93.3672 67.2905 95.0712Z"
        fill="white"
      />
      <path
        d="M89.2084 66.7423L88.7286 66.6016L89.2084 66.7423ZM66.5226 97.7552L66.6634 97.2754L66.6634 97.2754L66.5226 97.7552ZM86.872 28.389L87.0127 27.9092L87.0127 27.9092L86.872 28.389ZM64.1862 59.4018L64.666 59.5426L64.1862 59.4018ZM87.2237 66.0606L86.7439 65.9199L87.2237 66.0606ZM67.2905 95.0712L67.1498 95.551L67.2905 95.0712ZM86.1219 30.8792L86.2627 30.3994L86.1219 30.8792ZM66.1888 59.8898L66.6685 60.0305L66.1888 59.8898ZM88.7286 66.6016C85.9308 76.1385 82.0089 84.3424 77.9459 89.8968C75.913 92.6758 73.8614 94.7687 71.9184 96.0398C69.9732 97.3123 68.1968 97.7252 66.6634 97.2754L66.3819 98.2349C68.3033 98.7986 70.3877 98.2361 72.4658 96.8767C74.5461 95.5158 76.6805 93.3204 78.753 90.4872C82.9006 84.8172 86.8666 76.5011 89.6882 66.8831L88.7286 66.6016ZM86.7312 28.8687C88.2646 29.3186 89.5364 30.6258 90.4859 32.7474C91.4343 34.8667 92.0301 37.7363 92.2395 41.1731C92.6579 48.0422 91.5264 57.0646 88.7286 66.6016L89.6882 66.8831C92.5097 57.2651 93.6648 48.1243 93.2376 41.1123C93.0242 37.6085 92.4141 34.6079 91.3987 32.3389C90.3843 30.0722 88.9342 28.4729 87.0127 27.9092L86.7312 28.8687ZM64.666 59.5426C67.4638 50.0056 71.3857 41.8018 75.4488 36.2473C77.4816 33.4683 79.5332 31.3754 81.4762 30.1043C83.4214 28.8319 85.1978 28.4189 86.7312 28.8687L87.0127 27.9092C85.0913 27.3455 83.007 27.908 80.9288 29.2675C78.8485 30.6283 76.7141 32.8237 74.6417 35.6569C70.4941 41.327 66.528 49.643 63.7064 59.2611L64.666 59.5426ZM66.6634 97.2754C65.13 96.8255 63.8582 95.5184 62.9087 93.3967C61.9603 91.2774 61.3645 88.4078 61.1551 84.9711C60.7367 78.1019 61.8682 69.0795 64.666 59.5426L63.7064 59.2611C60.8849 68.8791 59.7298 78.0198 60.157 85.0319C60.3704 88.5357 60.9805 91.5362 61.996 93.8052C63.0104 96.0719 64.4605 97.6713 66.3819 98.2349L66.6634 97.2754ZM86.7439 65.9199C84.1545 74.7464 80.643 82.3735 77.0732 87.5691C75.2866 90.1692 73.5018 92.1363 71.8312 93.3448C70.1538 94.5584 68.6698 94.9548 67.4312 94.5915L67.1498 95.551C68.8155 96.0397 70.6253 95.4516 72.4174 94.1551C74.2163 92.8536 76.0767 90.7851 77.8974 88.1354C81.5419 82.8312 85.0927 75.101 87.7035 66.2014L86.7439 65.9199ZM85.9812 31.3589C87.2198 31.7223 88.2544 32.8576 89.0104 34.785C89.7633 36.7045 90.2026 39.324 90.3013 42.4772C90.4987 48.778 89.3333 57.0933 86.7439 65.9199L87.7035 66.2014C90.3143 57.3017 91.5023 48.8784 91.3009 42.4459C91.2002 39.2326 90.7521 36.4868 89.9413 34.4198C89.1337 32.3606 87.9284 30.888 86.2627 30.3994L85.9812 31.3589ZM66.6685 60.0305C69.2579 51.204 72.7694 43.5769 76.3393 38.3813C78.1258 35.7812 79.9106 33.8141 81.5812 32.6056C83.2586 31.392 84.7426 30.9956 85.9812 31.3589L86.2627 30.3994C84.5969 29.9107 82.7872 30.4988 80.9951 31.7953C79.1961 33.0968 77.3357 35.1653 75.5151 37.815C71.8706 43.1192 68.3198 50.8494 65.709 59.749L66.6685 60.0305ZM67.4312 94.5915C66.1927 94.2281 65.158 93.0928 64.402 91.1654C63.6491 89.2459 63.2098 86.6264 63.1111 83.4732C62.9138 77.1724 64.0792 68.8571 66.6685 60.0305L65.709 59.749C63.0982 68.6487 61.9101 77.072 62.1116 83.5045C62.2122 86.7178 62.6603 89.4636 63.4711 91.5306C64.2788 93.5898 65.484 95.0624 67.1498 95.551L67.4312 94.5915Z"
        fill="black"
      />
      <path
        d="M71.3922 61.4411C67.4288 73.4133 66.5785 83.9302 69.0186 91.5719C69.6299 94.3691 71.1843 94.3589 71.1843 94.3589C69.7948 95.1536 68.477 95.4193 67.2895 95.071C61.4809 93.3669 60.9876 77.6157 66.1878 59.8895C71.388 42.1633 80.3123 29.1748 86.121 30.8789C87.2843 31.2202 88.2345 32.1249 88.9684 33.4962C88.9684 33.4962 78.7997 35.7541 71.3922 61.4411Z"
        fill="white"
        stroke="black"
      />
      <path
        d="M88.9689 33.4963C88.235 32.125 87.2848 31.2202 86.1214 30.8789C80.9253 29.3546 73.236 39.5874 67.9496 54.4514C69.6898 54.966 71.3926 61.4412 71.3926 61.4412C71.3926 61.4412 72.214 58.6923 72.6351 57.4202C79.8857 35.5131 88.9689 33.4963 88.9689 33.4963Z"
        fill="#00C6A2"
        stroke="black"
      />
      <path
        d="M88.97 33.4963C88.2361 32.125 87.2859 31.2202 86.1226 30.8789C83.3597 30.0684 79.8919 32.582 76.4552 37.3484C76.4552 37.3484 77.4112 37.9937 78.0537 40.3305C78.6962 42.6674 78.0431 44.8001 78.0431 44.8001C83.7363 34.6584 88.97 33.4963 88.97 33.4963Z"
        fill="black"
        stroke="black"
      />
      <path
        d="M29.7656 41.0029L39.1471 43.5167L44.5244 44.9575C45.4061 45.6172 45.938 46.9239 45.9703 47.4618L44.6343 49.4853L45.9285 49.8321C46.1093 50.1451 46.087 52.2031 44.5523 57.9308C43.0176 63.6584 39.9005 65.4164 38.5338 65.5794L40.0659 77.1497C40.2531 78.5634 38.943 79.7132 37.5656 79.3441L34.4382 78.5061L20.7028 74.8258L24.9365 59.0253L27.9525 54.8059L26.1934 54.3346L29.7656 41.0029Z"
        fill="white"
      />
      <path
        d="M39.1471 43.5167L29.7656 41.0029L26.1934 54.3346M39.1471 43.5167C39.6409 43.649 40.7201 44.3615 41.0868 46.1533M39.1471 43.5167L44.5244 44.9575C45.4061 45.6172 45.938 46.9239 45.9703 47.4618M41.0868 46.1533L32.5946 57.1082M41.0868 46.1533L45.9703 47.4618M32.5946 57.1082L34.6183 57.6504M32.5946 57.1082L31.9205 52.4292M26.1934 54.3346L31.2067 47.475L31.9205 52.4292M26.1934 54.3346L27.9525 54.8059M41.4789 48.6398C41.6596 48.9529 41.6374 51.0108 40.1027 56.7385C38.568 62.4662 35.1217 64.1359 33.5904 64.2548M41.4789 48.6398L44.6343 49.4853M41.4789 48.6398L34.6183 57.6504M30.016 51.9189L31.2716 62.0458L34.6183 57.6504M30.016 51.9189L27.9525 54.8059M30.016 51.9189L31.9205 52.4292M34.4382 78.5061L20.7028 74.8258L24.9365 59.0253L27.9525 54.8059M34.4382 78.5061L33.5904 64.2548M34.4382 78.5061L37.5656 79.3441C38.943 79.7132 40.2531 78.5634 40.0659 77.1497L38.5338 65.5794M33.5904 64.2548L38.5338 65.5794M38.5338 65.5794C39.9005 65.4164 43.0176 63.6584 44.5523 57.9308C46.087 52.2031 46.1093 50.1451 45.9285 49.8321L44.6343 49.4853M45.9703 47.4618L44.6343 49.4853"
        stroke="black"
      />
      <path
        d="M26.1934 54.3345L31.2067 47.475L31.9205 52.4292L30.016 51.9189L27.9525 54.8058L26.1934 54.3345Z"
        fill="black"
        stroke="black"
      />
      <path
        d="M32.5948 57.1083L41.0869 46.1533L46.1706 47.5155L44.6344 49.4854L41.479 48.6399L34.6184 57.6505L32.5948 57.1083Z"
        fill="black"
        stroke="black"
      />
      <path
        d="M42.5244 42.7607L44.9932 43.4223L49.9367 44.7469L48.1506 51.4127L43.2071 50.0881L42.5244 42.7607Z"
        fill="#00C6A2"
      />
      <path
        d="M44.9932 43.4223L42.5244 42.7607L43.2071 50.0881M44.9932 43.4223L43.2071 50.0881M44.9932 43.4223L49.9367 44.7469L48.1506 51.4127L43.2071 50.0881"
        stroke="black"
      />
      <path
        d="M39.1471 43.5167L31.6975 41.5206C30.6305 41.2347 29.5339 41.8679 29.248 42.9348L26.1934 54.3346L31.2067 47.475L31.9205 52.4292L32.5946 57.1082L41.0868 46.1533C40.7201 44.3615 39.6409 43.649 39.1471 43.5167Z"
        fill="#00C6A2"
        stroke="black"
      />
      <path
        d="M43.2071 50.0877L44.9932 43.4219L49.9366 44.7465L48.1505 51.4123L43.2071 50.0877Z"
        fill="white"
        stroke="black"
      />
      <path
        d="M30.0146 51.9192L31.2702 62.0461L34.6169 57.6507L41.4775 48.6401C41.6582 48.9531 41.636 51.0111 40.1013 56.7388C38.5666 62.4664 35.1203 64.1362 33.589 64.2551L34.9284 75.8049C35.091 77.2076 33.7881 78.3326 32.424 77.9671L22.6333 75.3437C21.5663 75.0578 20.9332 73.9611 21.2191 72.8942L24.9351 59.0256L30.0146 51.9192Z"
        fill="#00C6A2"
        stroke="black"
      />
      <path
        d="M76.966 42.999C77.1376 42.6902 77.6302 42.1126 78.2274 42.2726L83.5501 43.6988C84.1145 43.8501 84.2161 44.9763 84.0917 45.4405L75.71 76.7213C75.3812 77.6975 74.7613 79.6601 73.4065 79.2971L68.5145 77.9863C67.5192 77.7196 67.3878 72.2394 67.3878 72.2394L66.054 74.7955C65.4037 76.0415 63.9755 76.6691 62.6179 76.3053L59.132 75.3713C58.6737 75.2777 58.3217 74.7593 58.6634 73.4841C58.7538 73.1467 64.5953 50.6824 67.3112 41.2102C67.5865 40.2501 68.144 39.9378 68.8065 40.018C68.8503 40.0233 68.8935 40.0347 68.9357 40.0526L73.2804 41.2168C73.6567 41.3176 73.761 41.6808 73.8894 42.7068C74.0179 43.7327 74.2443 47.188 74.2678 48.0682L76.966 42.999Z"
        fill="white"
      />
      <path
        d="M78.2274 42.2726C77.6302 42.1126 77.1376 42.6902 76.966 42.999L74.2678 48.0682M78.2274 42.2726C79.0345 42.4889 79.021 43.2919 78.757 44.2771L74.5994 59.7934L70.4419 75.3097C70.1758 76.3027 69.5098 78.253 68.5145 77.9863M78.2274 42.2726L83.5501 43.6988C84.1145 43.8501 84.2161 44.9763 84.0917 45.4405C83.9674 45.9046 78.4521 66.4877 75.71 76.7213C75.3812 77.6975 74.7613 79.6601 73.4065 79.2971C72.0518 78.9341 69.7062 78.3056 68.5145 77.9863M68.5145 77.9863C67.5192 77.7196 67.3878 72.2394 67.3878 72.2394M67.3878 72.2394L66.054 74.7955C65.4037 76.0415 63.9755 76.6691 62.6179 76.3053L59.132 75.3713M67.3878 72.2394L67.4999 62.6799M59.132 75.3713C59.5011 75.4466 59.9391 75.2463 60.1391 74.9438C62.0714 71.3816 66.0026 64.009 66.2687 63.0159C66.4002 62.5251 66.3586 62.3562 66.2522 62.3456M59.132 75.3713C58.6737 75.2777 58.3217 74.7593 58.6634 73.4841C58.7538 73.1467 64.5953 50.6824 67.3112 41.2102C67.5865 40.2501 68.144 39.9378 68.8065 40.018M66.2522 62.3456C66.1432 62.3347 65.9664 62.4894 65.8376 62.6343C64.6197 64.5254 62.1342 68.2941 61.9352 68.2408C61.7361 68.1875 61.7307 68.0086 61.7529 67.9259L67.3899 47.8834L67.4999 62.6799M66.2522 62.3456L67.4999 62.6799M68.8065 40.018C69.1567 40.0604 69.4618 40.4899 69.6172 41.562C70.0665 44.6626 69.8697 61.8521 69.7152 70.0594C69.7982 70.0816 70.0173 69.9274 70.2302 69.133C70.382 68.5666 72.1208 62.0771 73.7012 56.1791M68.8065 40.018L73.2804 41.2168C73.6567 41.3176 73.761 41.6808 73.8894 42.7068C74.0179 43.7327 74.2443 47.188 74.2678 48.0682M74.2678 48.0682L70.9694 54.4303C70.6641 55.0471 70.7009 55.3658 70.885 55.4245M70.885 55.4245C70.9815 55.4553 71.1183 55.4148 71.2676 55.3085L75.4188 49.7687C74.9479 51.5263 74.3374 53.8048 73.7012 56.1791M70.885 55.4245L73.7012 56.1791"
        stroke="black"
        stroke-linejoin="round"
      />
      <path
        d="M69.9668 56.5952C69.967 56.5962 69.9672 56.5972 69.9674 56.5983C69.9841 56.6853 70.3538 58.5685 71.2434 59.3572C71.8951 59.9352 72.3969 60.0697 72.6478 60.1369L70.379 68.6039C70.2177 69.206 69.8884 69.6824 69.8884 69.6824C69.9145 65.3324 70.036 56.9844 69.9674 56.5983C69.967 56.5963 69.9668 56.5952 69.9668 56.5952Z"
        fill="black"
      />
      <path
        d="M76.966 42.999C77.1376 42.6902 77.6302 42.1126 78.2274 42.2726C79.0345 42.4889 79.021 43.2919 78.757 44.2771L74.5994 59.7934L70.4419 75.3097C70.1758 76.3027 69.5098 78.253 68.5145 77.9863C67.5192 77.7196 67.3878 72.2394 67.3878 72.2394L67.4999 62.6799L66.2815 62.3535C66.3651 62.3925 66.3873 62.5733 66.2687 63.0159C66.0026 64.009 62.0714 71.3816 60.1391 74.9438C59.9391 75.2463 59.5011 75.4466 59.132 75.3713C58.6737 75.2777 58.3217 74.7593 58.6634 73.4841C58.7538 73.1467 64.5953 50.6824 67.3112 41.2102C67.5865 40.2501 68.144 39.9378 68.8065 40.018C69.1567 40.0604 69.4618 40.4899 69.6172 41.562C70.0665 44.6626 69.8697 61.8521 69.7152 70.0594C69.7982 70.0816 70.0173 69.9274 70.2302 69.133L73.7012 56.1791L70.9029 55.4293C70.8968 55.428 70.8909 55.4264 70.885 55.4245C70.7009 55.3658 70.6641 55.0471 70.9694 54.4303L74.2678 48.0682L76.966 42.999Z"
        fill="#00C6A2"
      />
      <path
        d="M66.2522 62.3456C66.1432 62.3347 65.9664 62.4894 65.8376 62.6343C64.6197 64.5254 62.1342 68.2941 61.9352 68.2408C61.7361 68.1875 61.7307 68.0086 61.7529 67.9259L67.3899 47.8834L67.4999 62.6799M66.2522 62.3456C66.3586 62.3562 66.4002 62.5251 66.2687 63.0159C66.0026 64.009 62.0715 71.3816 60.1391 74.9438C59.9391 75.2463 59.5011 75.4466 59.132 75.3713C58.6737 75.2777 58.3217 74.7593 58.6634 73.4841C58.7538 73.1467 64.5953 50.6824 67.3112 41.2102C67.5865 40.2501 68.144 39.9378 68.8065 40.018C69.1567 40.0604 69.4618 40.4899 69.6172 41.562C70.0665 44.6626 69.8697 61.8521 69.7152 70.0594C69.7982 70.0816 70.0173 69.9274 70.2302 69.133C70.382 68.5666 72.1208 62.0771 73.7012 56.1791M66.2522 62.3456L67.4999 62.6799M67.4999 62.6799L67.3878 72.2394C67.3878 72.2394 67.5192 77.7196 68.5145 77.9863C69.5098 78.253 70.1758 76.3027 70.4419 75.3097L74.5994 59.7934L78.757 44.2771C79.021 43.2919 79.0345 42.4889 78.2274 42.2726C77.6302 42.1126 77.1376 42.6902 76.966 42.999L74.2678 48.0682L70.9694 54.4303C70.6641 55.0471 70.7009 55.3658 70.885 55.4245M70.885 55.4245C70.9815 55.4553 71.1183 55.4148 71.2676 55.3085L75.4188 49.7687C74.9479 51.5263 74.3374 53.8048 73.7012 56.1791M70.885 55.4245L73.7012 56.1791"
        stroke="black"
        stroke-linejoin="round"
      />
      <path
        d="M61.9357 68.2409C61.7366 68.1876 61.7312 68.0088 61.7534 67.926L67.3904 47.8836L67.5004 62.6801L66.2527 62.3457C66.1437 62.3348 65.9669 62.4895 65.8381 62.6345C64.6202 64.5255 62.1347 68.2943 61.9357 68.2409Z"
        fill="black"
        stroke="black"
        stroke-linejoin="round"
      />
      <path
        d="M61.7525 67.9259L64.7791 57.6258C66.5464 59.0045 67.4996 62.68 67.4996 62.68L66.2518 62.3456C66.1428 62.3347 65.966 62.4894 65.8372 62.6344C64.6194 64.5254 62.1339 68.2942 61.9348 68.2408C61.7357 68.1875 61.7303 68.0086 61.7525 67.9259Z"
        fill="white"
        stroke="black"
        stroke-linejoin="round"
      />
      <path
        d="M71.2674 55.309L75.4187 49.7692L73.701 56.1797L70.9027 55.4299C70.8966 55.4285 70.8907 55.4269 70.8849 55.4251L70.9027 55.4299C70.9978 55.4507 71.1271 55.4089 71.2674 55.309Z"
        fill="black"
      />
      <path
        d="M67.4991 62.7909L66.3702 62.4884L66.1685 63.241C66.0475 63.6926 62.8774 69.7535 62.3576 70.6898C62.3576 70.6898 63.2957 71.1025 64.0375 71.9466C65.0521 73.4284 65.3522 74.3155 65.5391 75.3739L67.3874 72.2392L67.4991 62.7909Z"
        fill="black"
      />
      <path
        d="M56.9189 68.7426L56.9188 68.7426L56.9151 68.7549C54.1255 78.2642 50.2109 86.4431 46.1533 91.9794C44.1232 94.7494 42.0739 96.835 40.1324 98.1011C38.1889 99.3685 36.4131 99.7793 34.8791 99.3292C34.1837 99.1252 32.9588 98.7762 31.9096 98.4786C31.8085 98.4499 31.709 98.4217 31.6117 98.3942C31.8441 98.3007 32.0974 98.1909 32.3695 98.0623C33.8548 97.3602 35.898 96.098 38.1854 93.8515C42.7608 89.358 48.2932 80.9471 52.3147 65.2524C56.3316 49.5759 55.8866 40.4025 54.3889 35.1169C53.7001 32.686 52.7886 31.0782 51.9879 30.0428C52.9339 30.3761 54.0102 30.7679 54.8413 31.1052L54.8645 31.1146L54.8886 31.1216C56.4224 31.5716 57.7217 32.9 58.706 35.0493C59.6883 37.1941 60.3245 40.0921 60.5622 43.5417C61.0374 50.4366 59.9136 59.4292 56.9189 68.7426Z"
        fill="white"
        stroke="black"
      />
      <path
        d="M34.726 99.8065C41.6239 101.83 51.7502 88.0133 57.3439 68.9459C57.927 66.9583 58.4378 64.992 58.8773 63.062C58.8773 63.062 57.2815 62.589 55.7664 60.7741C54.2512 58.9591 54.0379 56.4077 54.0379 56.4077C53.5806 59.0837 52.6092 61.9835 51.7888 65.185C43.7922 96.393 29.8435 98.415 29.8435 98.415C29.8435 98.415 33.3425 99.4006 34.726 99.8065Z"
        fill="#00C6A2"
        stroke="black"
      />
      <path
        d="M29.8436 98.4151C29.8436 98.4151 33.3486 99.4024 34.7345 99.809C38.1634 100.815 42.3886 97.9133 46.4602 92.4006C46.4602 92.4006 45.3985 92.1626 44.5384 90.0141C43.6782 87.8656 44.4081 85.3298 44.4081 85.3298C36.8215 99.5065 29.8436 98.4151 29.8436 98.4151Z"
        fill="black"
        stroke="black"
      />
      <path
        d="M49.3213 31.2702L49.9263 29.0123C53.8653 29.8661 59.6732 40.9015 51.7743 68.0256C44.6923 92.3443 33.7184 99.2852 29.7671 98.2265L30.4729 95.5925C33.144 96.9132 42.3441 91.7151 49.5029 68.2236C57.5708 41.749 52.4191 32.5036 49.3213 31.2702Z"
        fill="white"
      />
      <path
        d="M49.9263 29.0127C53.8653 29.8665 59.6733 40.9017 51.7743 68.0258C44.6923 92.3445 33.7184 99.2856 29.7671 98.2269M49.2709 31.4587C52.3687 32.6921 57.5708 41.7493 49.503 68.2238C42.3442 91.7153 32.5796 96.7622 30.473 95.5927"
        stroke="black"
        stroke-linejoin="round"
      />
      <path
        d="M94.0332 68.2348L94.033 68.2348L94.0294 68.2471C91.2397 77.7564 87.3252 85.9353 83.2676 91.4716C81.2374 94.2416 79.1881 96.3272 77.2467 97.5933C75.3032 98.8607 73.5273 99.2714 71.9934 98.8214C71.2979 98.6174 70.073 98.2683 69.0239 97.9708C68.9228 97.9421 68.8233 97.9139 68.726 97.8864C68.9584 97.7929 69.2116 97.6831 69.4838 97.5545C70.969 96.8524 73.0122 95.5902 75.2997 93.3437C79.875 88.8502 85.4075 80.4392 89.429 64.7446C93.4459 49.0681 93.0009 39.8947 91.5031 34.6091C90.8143 32.1782 89.9029 30.5704 89.1022 29.535C90.0482 29.8683 91.1245 30.2601 91.9556 30.5973L91.9788 30.6068L92.0028 30.6138C93.5366 31.0638 94.836 32.3922 95.8203 34.5414C96.8026 36.6863 97.4388 39.5843 97.6765 43.0339C98.1516 49.9288 97.0279 58.9214 94.0332 68.2348Z"
        fill="white"
        stroke="black"
      />
      <path
        d="M71.8413 99.2982C78.7391 101.322 88.8655 87.505 94.4591 68.4376C95.0422 66.45 95.553 64.4837 95.9925 62.5537C95.9925 62.5537 94.3967 62.0807 92.8816 60.2658C91.3665 58.4508 91.1531 55.8994 91.1531 55.8994C90.6958 58.5754 89.7244 61.4752 88.9041 64.6767C80.9075 95.8847 66.9587 97.9067 66.9587 97.9067C66.9587 97.9067 70.4578 98.8923 71.8413 99.2982Z"
        fill="#00C6A2"
        stroke="black"
      />
      <path
        d="M66.9588 97.9068C66.9588 97.9068 70.4639 98.8941 71.8497 99.3007C75.2786 100.307 79.5039 97.405 83.5755 91.8923C83.5755 91.8923 82.5137 91.6543 81.6536 89.5058C80.7934 87.3573 81.5233 84.8215 81.5233 84.8215C73.9368 98.9982 66.9588 97.9068 66.9588 97.9068Z"
        fill="black"
        stroke="black"
      />
      <path
        d="M86.4365 30.7619L87.0416 28.504C90.9805 29.3578 96.7885 40.3932 88.8895 67.5173C81.8075 91.836 70.8336 98.7769 66.8823 97.7182L67.5881 95.0842C70.2592 96.4049 79.4593 91.2068 86.6181 67.7153C94.686 41.2407 89.5344 31.9953 86.4365 30.7619Z"
        fill="white"
      />
      <path
        d="M87.0416 28.5049C90.9805 29.3587 96.7885 40.3939 88.8896 67.518C81.8076 91.8367 70.8336 98.7778 66.8824 97.7191M86.3862 30.9509C89.484 32.1843 94.6861 41.2414 86.6182 67.716C79.4594 91.2075 69.6948 96.2543 67.5882 95.0849"
        stroke="black"
        stroke-linejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M201.807 103.76C210.824 106.405 224.078 88.286 231.411 63.2894C238.744 38.2928 237.379 15.8848 228.362 13.2395C219.345 10.5943 206.091 28.7137 198.758 53.7103C191.425 78.7069 192.79 101.115 201.807 103.76ZM202.809 100.258C210.39 102.481 222.036 85.5319 228.822 62.3999C235.608 39.2678 234.964 18.7129 227.384 16.4892C219.804 14.2655 208.158 31.2151 201.372 54.3471C194.586 77.4792 195.229 98.0341 202.809 100.258Z"
        fill="white"
      />
      <path
        d="M231.411 63.2894L230.931 63.1487L231.411 63.2894ZM201.807 103.76L201.666 104.24L201.666 104.24L201.807 103.76ZM228.362 13.2395L228.221 13.7193L228.362 13.2395ZM198.758 53.7103L198.278 53.5695L198.758 53.7103ZM228.822 62.3999L229.301 62.5406L228.822 62.3999ZM202.809 100.258L202.95 99.778L202.809 100.258ZM227.384 16.4892L227.525 16.0095L227.384 16.4892ZM201.372 54.3471L201.851 54.4879L201.372 54.3471ZM230.931 63.1487C227.277 75.6064 222.152 86.3293 216.837 93.5953C214.178 97.2301 211.488 99.9769 208.932 101.649C206.373 103.323 204.008 103.885 201.948 103.28L201.666 104.24C204.114 104.958 206.787 104.247 209.479 102.486C212.173 100.724 214.946 97.8746 217.644 94.1857C223.044 86.8041 228.212 75.969 231.891 63.4302L230.931 63.1487ZM228.221 13.7193C230.282 14.3237 231.968 16.0741 233.217 18.8649C234.465 21.6534 235.245 25.418 235.519 29.9131C236.066 38.8989 234.586 50.6909 230.931 63.1487L231.891 63.4302C235.569 50.8913 237.073 38.981 236.517 29.8523C236.239 25.2902 235.445 21.3946 234.13 18.4564C232.816 15.5206 230.951 13.478 228.503 12.7598L228.221 13.7193ZM199.238 53.851C202.892 41.3933 208.017 30.6704 213.332 23.4044C215.991 19.7697 218.681 17.0228 221.237 15.3504C223.796 13.6767 226.161 13.1149 228.221 13.7193L228.503 12.7598C226.055 12.0415 223.382 12.7528 220.69 14.5136C217.996 16.2758 215.224 19.1251 212.525 22.814C207.125 30.1956 201.957 41.0307 198.278 53.5695L199.238 53.851ZM201.948 103.28C199.888 102.676 198.201 100.926 196.952 98.1348C195.704 95.3463 194.924 91.5817 194.65 87.0866C194.103 78.1008 195.583 66.3088 199.238 53.851L198.278 53.5695C194.6 66.1084 193.096 78.0187 193.652 87.1474C193.93 91.7095 194.724 95.6052 196.039 98.5433C197.353 101.479 199.218 103.522 201.666 104.24L201.948 103.28ZM228.342 62.2591C224.959 73.7886 220.371 83.7574 215.701 90.5541C213.365 93.9547 211.024 96.5371 208.824 98.1284C206.618 99.7247 204.632 100.271 202.95 99.778L202.669 100.738C204.777 101.356 207.089 100.618 209.41 98.9386C211.738 97.2545 214.155 94.5706 216.525 91.1204C221.27 84.2151 225.898 74.1432 229.301 62.5406L228.342 62.2591ZM227.243 16.969C228.925 17.4623 230.301 18.9953 231.295 21.5305C232.286 24.058 232.861 27.4956 232.99 31.6196C233.248 39.8619 231.724 50.7296 228.342 62.2591L229.301 62.5406C232.705 50.938 234.252 39.9623 233.99 31.5883C233.859 27.4041 233.275 23.8403 232.226 21.1654C231.18 18.4983 229.633 16.628 227.525 16.0095L227.243 16.969ZM201.851 54.4879C205.234 42.9584 209.822 32.9896 214.492 26.1929C216.829 22.7923 219.169 20.2099 221.369 18.6186C223.575 17.0223 225.562 16.4757 227.243 16.969L227.525 16.0095C225.416 15.3909 223.104 16.1291 220.783 17.8084C218.455 19.4925 216.039 22.1764 213.668 25.6266C208.923 32.5319 204.296 42.6038 200.892 54.2064L201.851 54.4879ZM202.95 99.778C201.269 99.2847 199.893 97.7517 198.898 95.2165C197.907 92.689 197.332 89.2515 197.203 85.1274C196.945 76.8851 198.469 66.0174 201.851 54.4879L200.892 54.2064C197.488 65.809 195.941 76.7847 196.204 85.1587C196.335 89.3429 196.918 92.9067 197.967 95.5816C199.013 98.2487 200.56 100.119 202.669 100.738L202.95 99.778Z"
        fill="black"
      />
      <path
        d="M208.164 56.3729C202.991 71.9962 201.882 85.7205 205.066 95.6926C205.864 99.3429 207.892 99.3295 207.892 99.3295C206.079 100.367 204.359 100.713 202.81 100.259C195.23 98.0351 194.586 77.4802 201.372 54.3481C208.158 31.2161 219.804 14.2665 227.384 16.4902C228.902 16.9356 230.142 18.1163 231.1 19.9058C231.1 19.9058 217.83 22.8522 208.164 56.3729Z"
        fill="white"
        stroke="black"
      />
      <path
        d="M231.1 19.9059C230.142 18.1164 228.902 16.9357 227.384 16.4903C220.603 14.5011 210.569 27.8546 203.67 47.2516C205.941 47.9231 208.163 56.373 208.163 56.373C208.163 56.373 209.235 52.7858 209.785 51.1257C219.246 22.5378 231.1 19.9059 231.1 19.9059Z"
        fill="#00C6A2"
        stroke="black"
      />
      <path
        d="M231.1 19.9057C230.142 18.1162 228.902 16.9355 227.384 16.4901C223.779 15.4324 219.253 18.7126 214.769 24.9326C214.769 24.9326 216.016 25.7747 216.855 28.8242C217.693 31.8737 216.841 34.6568 216.841 34.6568C224.27 21.4222 231.1 19.9057 231.1 19.9057Z"
        fill="black"
        stroke="black"
      />
      <rect
        x="210.059"
        y="26.0317"
        width="4.28544"
        height="7.79171"
        transform="rotate(15 210.059 26.0317)"
        fill="white"
        stroke="black"
      />
      <path
        d="M210.339 25.589L205.652 24.3332C205.126 24.1924 204.59 24.5 204.449 25.0266L202.582 31.9937L201.073 31.5893C200.548 31.4485 200.012 31.7561 199.87 32.2827L198.036 39.1279L195.909 38.5578C195.383 38.4171 194.847 38.7246 194.706 39.2513L192.473 47.585C192.332 48.1117 192.643 48.646 193.168 48.7868L195.295 49.3569L193.38 56.5068C193.239 57.0335 193.549 57.5679 194.074 57.7086L195.584 58.113L193.782 64.8364C193.641 65.363 193.952 65.8974 194.477 66.0382L196.482 66.5755L194.648 73.4207C194.507 73.9474 194.818 74.4818 195.343 74.6225L196.852 75.027L194.985 81.994C194.844 82.5207 195.155 83.0551 195.68 83.1959L198.375 83.9179C198.9 84.0586 199.436 83.7511 199.577 83.2244L201.444 76.2573L202.831 76.629C203.356 76.7698 203.893 76.4622 204.034 75.9356L205.868 69.0904L207.873 69.6277C208.399 69.7685 208.935 69.4609 209.076 68.9343L210.877 62.211L212.822 62.732C213.347 62.8727 213.883 62.5652 214.024 62.0385L215.94 54.8886L217.449 55.293C217.975 55.4338 218.511 55.1262 218.652 54.5996L220.885 46.2659C221.026 45.7392 220.716 45.2048 220.19 45.0641L218.681 44.6596L220.564 37.6316C220.705 37.105 220.395 36.5706 219.869 36.4298L217.925 35.9088L219.743 29.1246C219.884 28.5979 219.573 28.0635 219.048 27.9227L215.056 26.853C214.531 26.7123 213.994 27.0198 213.853 27.5465L212.036 34.3307L209.215 33.5751L211.033 26.7908C211.174 26.2642 210.864 25.7298 210.339 25.589ZM201.426 76.2526L201.427 76.2527C201.427 76.2527 201.426 76.2526 201.426 76.2526Z"
        fill="#00C6A2"
        stroke="black"
      />
      <path
        d="M219.453 29.0476C219.522 28.7886 219.421 28.3395 219.162 28.27L226.082 30.1243C226.616 30.2672 226.932 30.8156 226.789 31.349L224.975 38.1203L227.02 38.6681C227.553 38.8111 227.87 39.3577 227.727 39.8911L225.874 46.8066L227.355 47.2033C227.888 47.3463 228.204 47.8945 228.061 48.428L225.957 56.2802C225.814 56.8137 225.266 57.1303 224.733 56.9873L223.253 56.5907L221.344 63.7155C221.201 64.2489 220.652 64.5655 220.119 64.4226L218.074 63.8747L216.266 70.6232C216.123 71.1567 215.575 71.4732 215.041 71.3303L213.937 71.0345L212.129 77.783C211.986 78.3164 211.438 78.633 210.904 78.4901L208.947 77.9655L207.088 84.9021C206.945 85.4356 206.397 85.7522 205.863 85.6092L198.646 83.6755C198.906 83.745 199.218 83.4064 199.287 83.1474L201.129 76.274C201.198 76.015 201.445 75.9555 201.705 76.025L203.1 76.3988C203.359 76.4683 203.647 76.2181 203.717 75.9591L205.583 68.9951C205.652 68.7361 205.838 68.8644 206.098 68.934L208.121 69.476C208.38 69.5455 208.716 69.1163 208.786 68.8573L210.592 62.1157C210.661 61.8567 210.86 61.9416 211.119 62.0111L213.081 62.5368C213.34 62.6063 213.665 62.2205 213.734 61.9615L215.655 54.7933C215.724 54.5343 215.921 54.6261 216.18 54.6956L217.707 55.1047C217.966 55.1743 218.292 54.7816 218.362 54.5226L220.595 46.1889C220.664 45.9299 220.484 45.3623 220.224 45.2927L218.886 44.9341C218.626 44.8645 218.316 44.8599 218.386 44.6009L220.274 37.5546C220.343 37.2956 220.424 36.9009 220.165 36.8314L218.014 36.2306C217.826 36.1802 217.561 36.1091 217.63 35.8501L219.453 29.0476Z"
        fill="white"
      />
      <path
        d="M220.165 36.8313L218.014 36.2306C217.826 36.1802 217.561 36.1091 217.63 35.8501L219.453 29.0476C219.522 28.7886 219.421 28.3395 219.162 28.27L226.082 30.1243C226.616 30.2672 226.932 30.8156 226.789 31.349L224.975 38.1203M220.165 36.8313C220.424 36.9009 220.343 37.2956 220.274 37.5546L218.386 44.6009C218.316 44.8599 218.626 44.8645 218.886 44.9341C218.886 44.9341 219.628 45.133 220.224 45.2927M220.165 36.8313L224.975 38.1203M220.224 45.2927C220.484 45.3623 220.664 45.9299 220.595 46.1889L218.362 54.5226C218.292 54.7816 217.966 55.1743 217.707 55.1047M220.224 45.2927L225.874 46.8066M217.707 55.1047L216.18 54.6956C215.921 54.6261 215.724 54.5343 215.655 54.7933L213.734 61.9615C213.665 62.2205 213.34 62.6063 213.081 62.5368M217.707 55.1047L223.253 56.5907M213.081 62.5368L211.119 62.0111C210.86 61.9416 210.661 61.8567 210.592 62.1157L208.786 68.8573C208.716 69.1163 208.38 69.5455 208.121 69.476M213.081 62.5368L218.074 63.8747M208.121 69.476L206.098 68.934C205.838 68.8644 205.652 68.7361 205.583 68.9951L203.717 75.9591C203.647 76.2181 203.359 76.4683 203.1 76.3988M208.121 69.476L213.937 71.0345M203.1 76.3988L201.705 76.025C201.445 75.9555 201.198 76.015 201.129 76.274L199.287 83.1474C199.218 83.4064 198.906 83.745 198.646 83.6755L205.863 85.6092C206.397 85.7522 206.945 85.4356 207.088 84.9021L208.947 77.9655M203.1 76.3988L208.947 77.9655M224.975 38.1203L227.02 38.6681C227.553 38.8111 227.87 39.3577 227.727 39.8911C227.302 41.4774 226.446 44.6741 225.874 46.8066M225.874 46.8066C226.367 46.9386 226.907 47.0834 227.355 47.2033C227.888 47.3463 228.204 47.8945 228.061 48.428L225.957 56.2802C225.814 56.8137 225.266 57.1303 224.733 56.9873L223.253 56.5907M223.253 56.5907L221.344 63.7155C221.201 64.2489 220.652 64.5655 220.119 64.4226L218.074 63.8747M218.074 63.8747L216.266 70.6232C216.123 71.1567 215.575 71.4732 215.041 71.3303L213.937 71.0345M213.937 71.0345L212.129 77.783C211.986 78.3164 211.438 78.633 210.904 78.4901L208.947 77.9655"
        stroke="black"
      />
      <path
        d="M216.551 67.6105C216.1 66.839 215.329 65.8893 214.046 65.12C212.792 64.3679 211.787 63.9904 211.081 63.8015C210.888 63.7497 210.718 63.7122 210.571 63.685L210.897 62.4683L217.458 64.2262L216.551 67.6105Z"
        fill="black"
        stroke="black"
      />
      <path
        d="M221.778 60.1383C221.327 59.3668 220.557 58.4171 219.274 57.6479C218.02 56.8957 217.014 56.5183 216.309 56.3293C216.116 56.2776 215.946 56.24 215.799 56.2128L215.996 55.4791C216.067 55.2124 216.341 55.0541 216.608 55.1256L222.685 56.754L221.778 60.1383Z"
        fill="black"
        stroke="black"
      />
      <path
        d="M212.468 31.6687C212.152 31.9202 211.787 32.1392 211.379 32.2671C210.636 32.5001 210.08 32.4948 209.679 32.396L209.487 33.1112C209.415 33.378 209.574 33.6521 209.84 33.7236L211.778 34.2429L212.468 31.6687Z"
        fill="black"
        stroke="black"
      />
      <path
        d="M212.173 74.9129C212.159 74.8881 212.144 74.8632 212.129 74.838C211.634 74.0059 210.783 72.9717 209.36 72.1316C207.982 71.318 206.88 70.908 206.11 70.7017C205.875 70.6387 205.671 70.5948 205.5 70.5642L205.869 69.1876L213.182 71.1471L212.173 74.9129Z"
        fill="black"
        stroke="black"
      />
      <path
        d="M207.432 82.0715C207.429 82.0664 207.426 82.0614 207.424 82.0563C206.958 81.2312 206.153 80.2056 204.793 79.3801C203.479 78.5828 202.425 78.1849 201.686 77.9868C201.472 77.9295 201.285 77.8891 201.126 77.8605L201.365 76.9689C201.436 76.7021 201.71 76.5438 201.977 76.6153L208.431 78.3446L207.432 82.0715Z"
        fill="black"
        stroke="black"
      />
      <path
        d="M237.854 65.2844L237.854 65.2843L237.85 65.2967C234.206 77.7184 229.091 88.4087 223.783 95.6511C221.128 99.2741 218.441 102.011 215.886 103.677C213.33 105.344 210.965 105.903 208.905 105.299C207.998 105.033 206.4 104.577 205.031 104.189C204.742 104.107 204.463 104.028 204.203 103.954C204.61 103.804 205.081 103.61 205.607 103.361C207.53 102.452 210.182 100.815 213.155 97.8952C219.101 92.0555 226.31 81.1068 231.553 60.6453C236.791 40.2019 236.205 28.2606 234.26 21.3988C233.287 17.9644 231.974 15.8034 230.883 14.4914C230.861 14.4653 230.839 14.4396 230.818 14.4142C230.829 14.418 230.839 14.4218 230.85 14.4256C232.187 14.8921 233.825 15.4817 235.055 15.9808L235.078 15.9902L235.102 15.9972C237.163 16.6017 238.885 18.3797 240.179 21.2055C241.472 24.0269 242.304 27.8285 242.615 32.3408C243.237 41.3613 241.767 53.1158 237.854 65.2844Z"
        fill="white"
        stroke="black"
      />
      <path
        d="M208.75 105.774C217.752 108.415 230.966 90.3847 238.266 65.5025C239.027 62.9086 239.693 60.3427 240.267 57.8241C240.267 57.8241 238.184 57.2069 236.207 54.8384C234.23 52.47 233.951 49.1405 233.951 49.1405C233.355 52.6326 232.087 56.4167 231.016 60.5946C220.581 101.32 202.378 103.959 202.378 103.959C202.378 103.959 206.945 105.245 208.75 105.774Z"
        fill="#00C6A2"
        stroke="black"
      />
      <path
        d="M202.378 103.958C202.378 103.958 206.952 105.247 208.76 105.777C213.235 107.09 218.748 103.303 224.062 96.1095C224.062 96.1095 222.676 95.7989 221.554 92.9951C220.431 90.1914 221.384 86.8823 221.384 86.8823C211.484 105.382 202.378 103.958 202.378 103.958Z"
        fill="black"
        stroke="black"
      />
      <path
        d="M227.795 16.3371L228.584 13.3906C233.725 14.5047 241.304 28.9056 230.996 64.3016C221.754 96.0368 207.434 105.094 202.277 103.713L203.198 100.276C206.684 101.999 218.69 95.2157 228.032 64.5601C238.56 30.0117 231.837 17.9466 227.795 16.3371Z"
        fill="white"
      />
      <path
        d="M228.584 13.391C233.725 14.5051 241.304 28.9058 230.996 64.3018C221.754 96.0369 207.434 105.095 202.277 103.713M227.729 16.583C231.772 18.1925 238.56 30.0118 228.032 64.5602C218.69 95.2158 205.947 101.802 203.198 100.276"
        stroke="black"
        stroke-linejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M134.82 103.76C143.837 106.405 157.091 88.286 164.424 63.2894C171.757 38.2928 170.392 15.8848 161.375 13.2395C152.358 10.5943 139.104 28.7137 131.771 53.7103C124.438 78.7069 125.803 101.115 134.82 103.76ZM135.822 100.258C143.402 102.481 155.048 85.5319 161.834 62.3999C168.62 39.2678 167.977 18.7129 160.397 16.4892C152.816 14.2655 141.17 31.2151 134.384 54.3471C127.598 77.4792 128.242 98.0341 135.822 100.258Z"
        fill="white"
      />
      <path
        d="M164.424 63.2894L163.944 63.1487L164.424 63.2894ZM134.82 103.76L134.96 103.28L134.96 103.28L134.82 103.76ZM161.375 13.2395L161.234 13.7193L161.375 13.2395ZM131.771 53.7103L132.25 53.851L131.771 53.7103ZM161.834 62.3999L161.354 62.2591L161.834 62.3999ZM135.822 100.258L135.963 99.778L135.822 100.258ZM160.397 16.4892L160.256 16.969L160.397 16.4892ZM134.384 54.3471L133.905 54.2064L134.384 54.3471ZM163.944 63.1487C160.289 75.6064 155.165 86.3293 149.85 93.5953C147.191 97.2301 144.501 99.9769 141.944 101.649C139.386 103.323 137.021 103.885 134.96 103.28L134.679 104.24C137.127 104.958 139.8 104.247 142.492 102.486C145.186 100.724 147.958 97.8746 150.657 94.1857C156.056 86.8041 161.225 75.969 164.904 63.4302L163.944 63.1487ZM161.234 13.7193C163.294 14.3237 164.981 16.0741 166.23 18.8649C167.478 21.6534 168.258 25.418 168.531 29.9131C169.079 38.8989 167.599 50.6909 163.944 63.1487L164.904 63.4302C168.582 50.8913 170.086 38.981 169.53 29.8523C169.252 25.2902 168.458 21.3946 167.143 18.4564C165.829 15.5206 163.964 13.478 161.516 12.7598L161.234 13.7193ZM132.25 53.851C135.905 41.3933 141.03 30.6704 146.345 23.4044C149.004 19.7697 151.694 17.0228 154.25 15.3504C156.809 13.6767 159.174 13.1149 161.234 13.7193L161.516 12.7598C159.067 12.0415 156.394 12.7528 153.703 14.5136C151.009 16.2758 148.236 19.1251 145.538 22.814C140.138 30.1956 134.969 41.0307 131.291 53.5695L132.25 53.851ZM134.96 103.28C132.9 102.676 131.213 100.926 129.964 98.1348C128.717 95.3463 127.937 91.5817 127.663 87.0866C127.116 78.1008 128.596 66.3088 132.25 53.851L131.291 53.5695C127.613 66.1084 126.109 78.0187 126.665 87.1474C126.943 91.7095 127.737 95.6052 129.052 98.5433C130.366 101.479 132.231 103.522 134.679 104.24L134.96 103.28ZM161.354 62.2591C157.972 73.7886 153.384 83.7574 148.714 90.5541C146.377 93.9547 144.037 96.5371 141.837 98.1284C139.631 99.7247 137.644 100.271 135.963 99.778L135.681 100.738C137.79 101.356 140.102 100.618 142.423 98.9386C144.751 97.2545 147.167 94.5706 149.538 91.1204C154.283 84.2151 158.91 74.1432 162.314 62.5406L161.354 62.2591ZM160.256 16.969C161.937 17.4623 163.313 18.9953 164.308 21.5305C165.299 24.058 165.874 27.4956 166.003 31.6196C166.261 39.8619 164.737 50.7296 161.354 62.2591L162.314 62.5406C165.718 50.938 167.265 39.9623 167.002 31.5883C166.871 27.4041 166.288 23.8403 165.239 21.1654C164.193 18.4983 162.646 16.628 160.537 16.0095L160.256 16.969ZM134.864 54.4879C138.246 42.9584 142.835 32.9896 147.505 26.1929C149.841 22.7923 152.182 20.2099 154.382 18.6186C156.588 17.0223 158.574 16.4757 160.256 16.969L160.537 16.0095C158.429 15.3909 156.117 16.1291 153.796 17.8084C151.468 19.4925 149.051 22.1764 146.681 25.6266C141.936 32.5319 137.308 42.6038 133.905 54.2064L134.864 54.4879ZM135.963 99.778C134.281 99.2847 132.905 97.7517 131.911 95.2165C130.919 92.689 130.345 89.2514 130.216 85.1274C129.958 76.8851 131.482 66.0174 134.864 54.4879L133.905 54.2064C130.501 65.809 128.954 76.7847 129.216 85.1587C129.347 89.3429 129.931 92.9067 130.98 95.5816C132.026 98.2487 133.573 100.119 135.681 100.738L135.963 99.778Z"
        fill="black"
      />
      <path
        d="M141.176 56.3724C136.004 71.9958 134.894 85.72 138.079 95.6921C138.876 99.3424 140.905 99.3291 140.905 99.3291C139.092 100.366 137.372 100.713 135.822 100.258C128.242 98.0346 127.599 77.4797 134.385 54.3477C141.171 31.2156 152.817 14.266 160.397 16.4897C161.915 16.9351 163.155 18.1158 164.113 19.9053C164.113 19.9053 150.843 22.8518 141.176 56.3724Z"
        fill="white"
        stroke="black"
      />
      <path
        d="M164.112 19.9054C163.155 18.1159 161.915 16.9352 160.397 16.4898C153.616 14.5006 143.581 27.8541 136.683 47.2511C138.954 47.9226 141.176 56.3725 141.176 56.3725C141.176 56.3725 142.248 52.7853 142.797 51.1252C152.259 22.5373 164.112 19.9054 164.112 19.9054Z"
        fill="#00C6A2"
        stroke="black"
      />
      <path
        d="M164.112 19.9052C163.154 18.1157 161.914 16.935 160.396 16.4896C156.791 15.4319 152.265 18.7121 147.78 24.9321C147.78 24.9321 149.028 25.7742 149.866 28.8237C150.705 31.8732 149.853 34.6563 149.853 34.6563C157.282 21.4217 164.112 19.9052 164.112 19.9052Z"
        fill="black"
        stroke="black"
      />
      <path
        d="M124.035 58.9523L122.399 58.5139L131.354 25.0943L134.199 25.8567L125.286 59.1188L125.157 59.6018L125.64 59.7312L129.136 60.668L129.619 60.7974L129.748 60.3144L138.661 27.0523L141.293 27.7576L132.338 61.1772L130.804 60.7661L130.321 60.6367L130.192 61.1196L127.358 71.6942L126.217 71.3883L125.734 71.2589L125.604 71.7419L122.694 82.6027L120.426 81.9949L123.336 71.1341L123.465 70.6511L122.982 70.5217L121.555 70.1392L124.388 59.5647L124.518 59.0817L124.035 58.9523Z"
        fill="#00C6A2"
        stroke="black"
      />
      <path
        d="M143.408 77.1263L146.441 77.9389L143.574 88.6386L137.504 87.0122L152.571 30.7789L158.641 32.4053L155.842 42.8511L152.81 42.0385L152.327 41.9091L152.197 42.3921L149.037 54.1871L148.908 54.67L149.39 54.7995L152.423 55.612L149.719 65.7036L146.686 64.891L146.203 64.7616L146.074 65.2446L143.054 76.514L142.925 76.9969L143.408 77.1263Z"
        fill="#00C6A2"
        stroke="black"
      />
      <rect
        x="146.998"
        y="78.0884"
        width="6.79171"
        height="11.0772"
        transform="rotate(15 146.998 78.0884)"
        fill="white"
        stroke="black"
      />
      <rect
        x="159.199"
        y="32.5548"
        width="6.79171"
        height="11.0772"
        transform="rotate(15 159.199 32.5548)"
        fill="white"
        stroke="black"
      />
      <rect
        x="146.462"
        y="65.0386"
        width="6.79171"
        height="11.8563"
        transform="rotate(15 146.462 65.0386)"
        fill="white"
        stroke="black"
      />
      <rect
        x="152.411"
        y="42.836"
        width="6.79171"
        height="11.8563"
        transform="rotate(15 152.411 42.836)"
        fill="white"
        stroke="black"
      />
      <path
        d="M156.725 52.9852C156.695 52.9083 156.664 52.8295 156.632 52.7491C156.182 51.6373 155.442 50.1901 154.28 48.8756C153.151 47.5972 152.356 47.0725 151.775 46.9167C151.758 46.9123 151.742 46.9082 151.726 46.9044L152.789 42.9376L158.973 44.5946L156.725 52.9852Z"
        fill="black"
        stroke="black"
      />
      <path
        d="M150.862 74.8606C150.831 74.7834 150.798 74.7042 150.764 74.6233C150.305 73.5432 149.553 72.137 148.382 70.8559C147.244 69.6092 146.448 69.0976 145.872 68.9432C145.855 68.9388 145.839 68.9347 145.823 68.9309L146.839 65.1402L153.023 66.7972L150.862 74.8606Z"
        fill="black"
        stroke="black"
      />
      <rect
        x="126.026"
        y="72.0665"
        width="6.40213"
        height="11.0772"
        transform="rotate(15 126.026 72.0665)"
        fill="white"
        stroke="black"
      />
      <rect
        x="130.457"
        y="61.5567"
        width="7.1813"
        height="10.6876"
        transform="rotate(15 130.457 61.5567)"
        fill="white"
        stroke="black"
      />
      <rect
        x="141.89"
        y="27.9175"
        width="6.79171"
        height="34.4523"
        transform="rotate(15 141.89 27.9175)"
        fill="white"
        stroke="black"
      />
      <rect
        x="134.582"
        y="25.9595"
        width="3.77556"
        height="34.3392"
        transform="rotate(15 134.582 25.9595)"
        fill="white"
        stroke="black"
      />
      <path
        d="M130.363 42.3373C130.511 43.1106 130.731 43.9437 131.06 44.6359C131.506 45.5726 131.939 46.1709 132.275 46.5429C132.385 46.665 132.485 46.7624 132.571 46.8392L129.038 60.0243L125.852 59.1708L130.363 42.3373Z"
        fill="black"
        stroke="black"
      />
      <path
        d="M134.84 71.4399C134.807 71.3321 134.772 71.2215 134.735 71.1084C134.303 69.7951 133.561 68.1186 132.317 66.7486C131.121 65.4314 130.288 64.8951 129.688 64.7343C129.662 64.7274 129.636 64.7211 129.611 64.7155L130.457 61.5567L137.017 63.3145L134.84 71.4399Z"
        fill="black"
        stroke="black"
      />
      <path
        d="M125.654 73.457L126.026 72.0665L132.21 73.7235L131.068 77.9869C131.02 77.9067 130.969 77.8237 130.915 77.7385C130.38 76.8963 129.527 75.8207 128.253 74.8894C127.02 73.988 126.224 73.6092 125.702 73.4696C125.686 73.4652 125.67 73.461 125.654 73.457Z"
        fill="black"
        stroke="black"
      />
      <rect
        x="152.948"
        y="55.8873"
        width="6.79171"
        height="9.9084"
        transform="rotate(15 152.948 55.8873)"
        fill="white"
        stroke="black"
      />
      <path
        d="M170.865 65.2834L170.864 65.2834L170.861 65.2957C167.217 77.7175 162.102 88.4077 156.794 95.6501C154.138 99.2731 151.451 102.01 148.897 103.676C146.34 105.343 143.976 105.902 141.915 105.298C141.008 105.032 139.411 104.576 138.042 104.188C137.753 104.106 137.474 104.027 137.213 103.953C137.621 103.803 138.092 103.609 138.618 103.36C140.541 102.451 143.193 100.814 146.166 97.8942C152.112 92.0546 159.32 81.1058 164.563 60.6443C169.802 40.2009 169.215 28.2597 167.271 21.3979C166.298 17.9634 164.985 15.8024 163.893 14.4904C163.872 14.4644 163.85 14.4386 163.829 14.4133C163.839 14.417 163.85 14.4208 163.861 14.4246C165.197 14.8911 166.836 15.4807 168.066 15.9798L168.089 15.9892L168.113 15.9962C170.173 16.6007 171.896 18.3787 173.19 21.2045C174.482 24.0259 175.315 27.8276 175.626 32.3398C176.248 41.3603 174.777 53.1149 170.865 65.2834Z"
        fill="white"
        stroke="black"
      />
      <path
        d="M141.761 105.773C150.762 108.414 163.977 90.3837 171.276 65.5015C172.037 62.9076 172.704 60.3417 173.277 57.8231C173.277 57.8231 171.195 57.2059 169.218 54.8375C167.241 52.469 166.962 49.1396 166.962 49.1396C166.365 52.6316 165.098 56.4157 164.027 60.5936C153.592 101.319 135.389 103.958 135.389 103.958C135.389 103.958 139.955 105.244 141.761 105.773Z"
        fill="#00C6A2"
        stroke="black"
      />
      <path
        d="M135.388 103.957C135.388 103.957 139.962 105.246 141.771 105.776C146.245 107.089 151.759 103.302 157.073 96.1085C157.073 96.1085 155.687 95.7979 154.565 92.9942C153.442 90.1904 154.395 86.8813 154.395 86.8813C144.494 105.381 135.388 103.957 135.388 103.957Z"
        fill="black"
        stroke="black"
      />
      <path
        d="M160.806 16.3361L161.595 13.3896C166.735 14.5038 174.314 28.9047 164.007 64.3007C154.765 96.0358 140.444 105.093 135.288 103.712L136.209 100.275C139.695 101.998 151.701 95.2147 161.043 64.5591C171.571 30.0107 164.848 17.9456 160.806 16.3361Z"
        fill="white"
      />
      <path
        d="M161.595 13.39C166.735 14.5042 174.315 28.9048 164.007 64.3008C154.765 96.0359 140.444 105.094 135.288 103.712M160.74 16.582C164.782 18.1915 171.571 30.0108 161.043 64.5592C151.701 95.2149 138.958 101.801 136.209 100.275"
        stroke="black"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const PoolDaoBannerMobile = () => {
  return (
    <div className="relative mt-11 h-24 flex flex-col bg-poolDaoBanner items-center rounded-lg">
      <div className="relative bottom-10">
        <POOL_DAO_ICONS_MOBILE />
      </div>

      <button
        onClick={() => {
          openUrl('/referendum');
        }}
        className="text-white text-base relative bottom-10"
      >
        <span>
          <FormattedMessage
            id="more_than_a_simple_pool"
            defaultMessage={'More than a simple pool'}
          />
        </span>

        <button className="text-white  hover:text-gradientFrom ml-1.5">
          <VEARROW />
        </button>
      </button>
    </div>
  );
};

export const NEAR_TEXT = () => {
  return (
    <svg
      width="172"
      height="43"
      viewBox="0 0 172 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.1">
        <path
          d="M37.36 43.0002V1.0002H28.24V26.8602L8.56004 1.0002H0.0400391V43.0002H9.16004V16.3002L29.5 43.0002H37.36Z"
          fill="url(#paint0_linear_1536_322)"
        />
        <path
          d="M79.4224 43.0002V34.7802H56.6224V25.9602H76.4224V17.7402H56.6224V9.2202H79.1224V1.0002H47.4424V43.0002H79.4224Z"
          fill="url(#paint1_linear_1536_322)"
        />
        <path
          d="M128.558 43.0002L110.558 0.700195H102.038L84.0377 43.0002H93.4577L97.2977 33.5802H115.058L118.898 43.0002H128.558ZM111.758 25.4202H100.598L106.178 11.8002L111.758 25.4202Z"
          fill="url(#paint2_linear_1536_322)"
        />
        <path
          d="M171.34 43.0002L161.08 28.0002C166.42 26.0202 170.08 21.7602 170.08 14.9802V14.8602C170.08 6.2202 164.14 1.0002 154.24 1.0002H135.04V43.0002H144.28V29.5602H151.54L160.54 43.0002H171.34ZM160.72 15.4602C160.72 19.0002 158.14 21.4002 153.64 21.4002H144.28V9.34019H153.46C157.96 9.34019 160.72 11.3802 160.72 15.3402V15.4602Z"
          fill="url(#paint3_linear_1536_322)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1536_322"
          x1="84.5"
          y1="-2"
          x2="84.5"
          y2="53"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7E8A93" />
          <stop offset="1" stopColor="#7E8A93" stop-opacity="0.29" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1536_322"
          x1="84.5"
          y1="-2"
          x2="84.5"
          y2="53"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7E8A93" />
          <stop offset="1" stopColor="#7E8A93" stop-opacity="0.29" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1536_322"
          x1="84.5"
          y1="-2"
          x2="84.5"
          y2="53"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7E8A93" />
          <stop offset="1" stopColor="#7E8A93" stop-opacity="0.29" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1536_322"
          x1="84.5"
          y1="-2"
          x2="84.5"
          y2="53"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7E8A93" />
          <stop offset="1" stopColor="#7E8A93" stop-opacity="0.29" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const BTC_TEXT = () => {
  return (
    <svg
      width="117"
      height="44"
      viewBox="0 0 117 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.1">
        <path
          d="M35.7 31.2V31.08C35.7 25.44 32.7 22.62 27.84 20.76C30.84 19.08 33.36 16.44 33.36 11.7V11.58C33.36 4.98 28.08 0.719998 19.5 0.719998H0V42.72H19.98C29.46 42.72 35.7 38.88 35.7 31.2ZM24.18 13.26C24.18 16.38 21.6 17.7 17.52 17.7H9V8.82H18.12C22.02 8.82 24.18 10.38 24.18 13.14V13.26ZM26.52 30.06C26.52 33.18 24.06 34.62 19.98 34.62H9V25.38H19.68C24.42 25.38 26.52 27.12 26.52 29.94V30.06Z"
          fill="url(#paint0_linear_1536_247)"
        />
        <path
          d="M74.5148 9.24V0.719998H39.7148V9.24H52.4948V42.72H61.7348V9.24H74.5148Z"
          fill="url(#paint1_linear_1536_247)"
        />
        <path
          d="M116.705 35.94L110.825 30C107.525 33 104.585 34.92 99.7847 34.92C92.5847 34.92 87.6047 28.92 87.6047 21.72V21.6C87.6047 14.4 92.7047 8.52 99.7847 8.52C103.985 8.52 107.285 10.32 110.525 13.26L116.405 6.48C112.505 2.64 107.765 0 99.8447 0C86.9447 0 77.9447 9.78 77.9447 21.72V21.84C77.9447 33.9 87.1247 43.44 99.4847 43.44C107.585 43.44 112.385 40.56 116.705 35.94Z"
          fill="url(#paint2_linear_1536_247)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1536_247"
          x1="56.5615"
          y1="-2.28027"
          x2="56.5615"
          y2="52.7197"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7E8A93" />
          <stop offset="1" stopColor="#7E8A93" stop-opacity="0.29" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1536_247"
          x1="56.5615"
          y1="-2.28027"
          x2="56.5615"
          y2="52.7197"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7E8A93" />
          <stop offset="1" stopColor="#7E8A93" stop-opacity="0.29" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1536_247"
          x1="56.5615"
          y1="-2.28027"
          x2="56.5615"
          y2="52.7197"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7E8A93" />
          <stop offset="1" stopColor="#7E8A93" stop-opacity="0.29" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const USD_TEXT = () => {
  return (
    <svg
      width="124"
      height="44"
      viewBox="0 0 124 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.1">
        <path
          d="M37.3159 24.3V0.599999H28.0759V24.66C28.0759 31.32 24.6559 34.74 19.0159 34.74C13.3759 34.74 9.95594 31.2 9.95594 24.36V0.599999H0.715942V24.6C0.715942 36.96 7.61594 43.26 18.8959 43.26C30.1759 43.26 37.3159 37.02 37.3159 24.3Z"
          fill="url(#paint0_linear_1536_104)"
        />
        <path
          d="M77.0875 30.18V30.06C77.0875 22.74 72.2875 19.68 63.7675 17.46C56.5075 15.6 54.7075 14.7 54.7075 11.94V11.82C54.7075 9.78 56.5675 8.16 60.1075 8.16C63.6475 8.16 67.3075 9.72 71.0275 12.3L75.8275 5.34C71.5675 1.92 66.3475 0 60.2275 0C51.6475 0 45.5275 5.04 45.5275 12.66V12.78C45.5275 21.12 50.9875 23.46 59.4475 25.62C66.4675 27.42 67.9075 28.62 67.9075 30.96V31.08C67.9075 33.54 65.6275 35.04 61.8475 35.04C57.0475 35.04 53.0875 33.06 49.3075 29.94L43.8475 36.48C48.8875 40.98 55.3075 43.2 61.6675 43.2C70.7275 43.2 77.0875 38.52 77.0875 30.18Z"
          fill="url(#paint1_linear_1536_104)"
        />
        <path
          d="M123.806 21.6V21.48C123.806 9.66 114.686 0.599999 101.486 0.599999H85.1064V42.6H101.486C114.686 42.6 123.806 33.42 123.806 21.6ZM114.146 21.72C114.146 29.16 109.046 34.26 101.486 34.26H94.3464V8.94H101.486C109.046 8.94 114.146 14.16 114.146 21.6V21.72Z"
          fill="url(#paint2_linear_1536_104)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1536_104"
          x1="61.5"
          y1="-2.3999"
          x2="61.5"
          y2="52.6001"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7E8A93" />
          <stop offset="1" stopColor="#7E8A93" stop-opacity="0.29" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1536_104"
          x1="61.5"
          y1="-2.3999"
          x2="61.5"
          y2="52.6001"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7E8A93" />
          <stop offset="1" stopColor="#7E8A93" stop-opacity="0.29" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1536_104"
          x1="61.5"
          y1="-2.3999"
          x2="61.5"
          y2="52.6001"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7E8A93" />
          <stop offset="1" stopColor="#7E8A93" stop-opacity="0.29" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const HeavyWarning = () => {
  return (
    <svg
      width="60"
      height="63"
      viewBox="0 0 60 63"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33.3552 29.6754C33.8237 29.96 33.9758 30.5686 33.6963 31.0402L31.7097 34.3908C31.3145 35.0574 31.7949 35.9008 32.5699 35.9008H37.7394C38.6075 35.9008 39.0633 36.9311 38.4793 37.5735L28.2915 48.7796C27.5242 49.6235 26.1691 48.7311 26.6413 47.6928L28.5424 43.5132C28.8436 42.8511 28.3595 42.0992 27.6321 42.0992H21.7552C20.9803 42.0992 20.4998 41.2559 20.895 40.5893L28.4344 27.8695C28.7181 27.3908 29.3381 27.2358 29.8137 27.5247L33.3552 29.6754Z"
        fill="#00D6AF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.15 56.7C1.4103 56.7 0 58.1103 0 59.85C0 61.5897 1.4103 63 3.15 63H11.138C11.1396 63 11.1412 63 11.1429 63H48.8571C48.8588 63 48.8604 63 48.862 63H56.85C58.5897 63 60 61.5897 60 59.85C60 58.1103 58.5897 56.7 56.85 56.7H52V36.129C52 23.9075 42.1503 14 30 14C17.8497 14 8 23.9075 8 36.129V56.7H3.15ZM33.1579 3.1579C33.1579 1.41384 31.7441 0 30 0C28.2559 0 26.8421 1.41384 26.8421 3.1579V6.2921C26.8421 8.03616 28.2559 9.45 30 9.45C31.7441 9.45 33.1579 8.03616 33.1579 6.2921V3.1579ZM54.3326 14.8329C55.5677 13.6006 55.5676 11.5996 54.3323 10.3674C53.1014 9.13955 51.109 9.13943 49.878 10.3671L47.6451 12.5939C46.4093 13.8263 46.4092 15.8279 47.6448 17.0605C48.8761 18.2886 50.8691 18.2885 52.1002 17.0602L54.3326 14.8329ZM10.122 10.3671C8.89099 9.13943 6.8986 9.13955 5.66769 10.3674C4.43242 11.5996 4.43231 13.6006 5.66743 14.8329L7.8998 17.0602C9.13091 18.2885 11.1239 18.2886 12.3552 17.0605C13.5908 15.8279 13.5907 13.8263 12.3549 12.5939L10.122 10.3671ZM14.2857 36.129C14.2857 27.3991 21.321 20.3226 30 20.3226C38.679 20.3226 45.7143 27.3991 45.7143 36.129V56.6774H14.2857V36.129Z"
        fill="url(#paint0_linear_18312_583)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_18312_583"
          x1="30"
          y1="0"
          x2="30"
          y2="63"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFDC49" />
          <stop offset="1" stopColor="#00A88A" />
        </linearGradient>
      </defs>
    </svg>
  );
};
